import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut, updatePassword,createUserWithEmailAndPassword } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

import { doc, getDoc, updateDoc, addDoc,setDoc , deleteDoc, collection, getDocs, orderBy , query, where, onSnapshot,arrayUnion,serverTimestamp, Timestamp   } from 'firebase/firestore';

import { db } from '../components/firebase-config.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faUserMd, faUser, faCalendarAlt, faKey, faBars, faSignOutAlt,
  faEdit, faEye, faFilter, faLock, faUnlock, faHistory, faTrash,
  faCalendarDay, faArrowLeft, faCalendarWeek, faChevronLeft, faChevronRight,
  faClock, faPhone, faEnvelope, faClinicMedical, faBroom, faBuilding,
  faCheckCircle, faUserPlus, faCalendarPlus, faCheck, faTimesCircle,
  faExclamationCircle, faList, faCalendarCheck, faSearch, faLink, faUnlink,
  faSync, faArchive, faFileAlt, faTrashAlt, faSave, faFileUpload,faShieldAlt,
  faFileDownload, faTimes, faMapMarkerAlt, faRedo, faStop, faFile,faPencilAlt ,
  faDownload, faFilePdf, faFileWord, faFileExcel, faIdCard, faAddressBook,
  faMedkit, faCog, faAngleRight, faAngleLeft, faInfoCircle,faDiagnoses ,
  faEllipsisV, faComments, faComment, faPaperPlane, faCircleNotch,faPlus,faDatabase,
  faUserFriends, faPaperclip, faMicrophone, faFileImage, faQrcode
} from '@fortawesome/free-solid-svg-icons';
import Medecins from "./Medecins.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import { initializeApp } from 'firebase/app';
import MedecinPatientManager from './MedecinPatientManager.js';
import QRCodeManager from './QRCodeManager.js';
import { AdvancedImage } from 'cloudinary-react';
import { CloudinaryUploadWidget } from 'cloudinary-react';
import cld from '../components/cloudinary-config.js';



const MedecinDashboard = () => {
  // États pour les données
  const storage = getStorage();
  const auth = getAuth();
  const navigate = useNavigate();

  const [medecinData, setMedecinData] = useState(null);
  const [form, setForm] = useState({});
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('rendezvous');
  const [backupTab, setBackupTab] = useState('rendezvous');

  const [rendezvous, setRendezvous] = useState([]);
  const [patients, setPatients] = useState([]);
  const [structures, setStructures] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 999);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [mobileDetailView, setMobileDetailView] = useState(null);
  const [affiliatedStructures, setAffiliatedStructures] = useState([]);
  const [pendingAffiliations, setPendingAffiliations] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [unsubscribeFunctions, setUnsubscribeFunctions] = useState([]);
  const [disaffiliationHistory, setDisaffiliationHistory] = useState([]);
  const [showModal, setShowModal] = useState(false);
const [mobileMessageTab, setMobileMessageTab] = useState('conversations');
const [messageTab, setMessageTab] = useState('conversations');
const [messagingTab, setMessagingTab] = useState('conversations');
const [searchPatient, setSearchPatient] = useState('');
const  [patientDetailTab , setPatientDetailTab] = useState('list');
const [error, setError] = useState(null);
const [patientSubTab, setPatientSubTab] = useState('list');


const [conversations, setConversations] = useState([]);
const [selectedConversation, setSelectedConversation] = useState(null);
const [messages, setMessages] = useState([]);
const [newMessage, setNewMessage] = useState('');
const [loadingMessages, setLoadingMessages] = useState(false);
const [sendingMessage, setSendingMessage] = useState(false);
const messagesEndRef = useRef(null);
const [messagePatients, setMessagePatients] = useState([]);
const [searchPatientTerm, setSearchPatientTerm] = useState('');

// États pour la vue calendrier
const [calendarView, setCalendarView] = useState('month');
const [currentMonth, setCurrentMonth] = useState(new Date());
const [selectedDate, setSelectedDate] = useState(null);
const [showDateModal, setShowDateModal] = useState(false);
const [showRdvDetailsModal, setShowRdvDetailsModal] = useState(false);
const [selectedRdv, setSelectedRdv] = useState(null);
const [searchStructure, setSearchStructure] = useState('');
const [filtreSpecialite, setFiltreSpecialite] = useState('');
const [rejectedAffiliations, setRejectedAffiliations] = useState([]);
const [specialites, setSpecialites] = useState([]);
const [allStructures, setAllStructures] = useState([]);
const [sentAffiliationRequests, setSentAffiliationRequests] = useState([]);
const [editingStatus, setEditingStatus] = useState(false);
const [newStatus, setNewStatus] = useState('');

// États pour la section Sauvegardes
const [backups, setBackups] = useState([]);
const [selectedBackup, setSelectedBackup] = useState(null);
const [backupNotes, setBackupNotes] = useState('');
const [backupFiles, setBackupFiles] = useState([]);
const [backupFileToUpload, setBackupFileToUpload] = useState(null);
const [backupSearchTerm, setBackupSearchTerm] = useState('');

const [searchTerm, setSearchTerm] = useState('');

// Ajoutez cet état avec les autres déclarations d'états au début de votre composant
const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

// 1. Ajoutez ces états pour gérer l'affichage des détails
const [showDetails, setShowDetails] = useState(false);
const [detailsType, setDetailsType] = useState(null); // 'patient', 'rdv', 'archive', etc.
const [detailsItem, setDetailsItem] = useState(null);
const [showPatientDetail, setShowPatientDetail] = useState(false);
const [affiliationSubTab, setAffiliationSubTab] = useState('list');
// Dans les déclarations d'état (useState), ajouter:
const [attachmentFile, setAttachmentFile] = useState(null);
const [isRecording, setIsRecording] = useState(false);
const [audioBlob, setAudioBlob] = useState(null);
const [mediaRecorder, setMediaRecorder] = useState(null);
const [recordingTime, setRecordingTime] = useState(0);
const [recordingTimer, setRecordingTimer] = useState(null);
// 1. Ajoutez un nouvel état pour stocker toutes les structures
const [allSystemStructures, setAllSystemStructures] = useState([]);

// 2. Créez une fonction pour charger toutes les structures
const loadAllStructures = async () => {
  try {
    const structuresQuery = query(collection(db, 'structures'));
    const querySnapshot = await getDocs(structuresQuery);
    const structuresList = [];
    
    querySnapshot.forEach((doc) => {
      structuresList.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    setAllSystemStructures(structuresList);
    console.log("Toutes les structures système chargées:", structuresList);
  } catch (error) {
    console.error("Erreur lors du chargement des structures:", error);
  }
};

// 3. Appelez cette fonction au chargement du composant
useEffect(() => {
  if (auth.currentUser) {
    loadAllStructures();
  }
}, [auth.currentUser]);

// 4. Créez un ensemble fusionné de structures pour le menu déroulant
const getAvailableStructures = useCallback((jour, dispo) => {
  // Commencez par les structures affiliées
  const structuresMap = new Map();
  
  // Ajoutez les structures affiliées
  affiliatedStructures.forEach(structure => {
    structuresMap.set(structure.id, structure);
  });
  
  // Si le médecin a une structure assignée pour ce jour qui n'est pas dans ses affiliations
  if (dispo.structureId && !structuresMap.has(dispo.structureId)) {
    // Cherchez cette structure dans toutes les structures du système
    const assignedStructure = allSystemStructures.find(s => s.id === dispo.structureId);
    if (assignedStructure) {
      structuresMap.set(assignedStructure.id, assignedStructure);
    }
  }
  
  // Convertir la Map en tableau pour le rendu
  return Array.from(structuresMap.values());
}, [affiliatedStructures, allSystemStructures]);
// Ajoutez ces états

// Ajoutez ces états au début de votre composant, avec les autres états
const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

// Ajoutez cette fonction avec les autres fonctions du composant
const toggleMobileMenu = () => {
  setMobileMenuOpen(!mobileMenuOpen);
};

// Ajoutez ces états au début du composant
const [previewFile, setPreviewFile] = useState(null);
const [showFilePreview, setShowFilePreview] = useState(false);
// Fonction pour ouvrir la prévisualisation d'un fichier
const handleOpenFilePreview = (file) => {
  setPreviewFile(file);
  setShowFilePreview(true);
};

// Fonction pour fermer la prévisualisation
const handleCloseFilePreview = () => {
  setPreviewFile(null);
  setShowFilePreview(false);
};

const loadMessagePatients = async () => {
  try {
    if (!auth.currentUser) return;
    
    // Récupérer les patients des structures affiliées
    const patientsMap = new Map();
    
    // Récupérer les patients des rendez-vous
    rendezvous.forEach(rdv => {
      if (rdv.patientId && !patientsMap.has(rdv.patientId)) {
        const patient = patients.find(p => p.id === rdv.patientId);
        if (patient) {
          patientsMap.set(rdv.patientId, patient);
        }
      }
    });
    
    // Récupérer également les patients des conversations existantes
    const conversationsQuery = query(
      collection(db, 'conversations'),
      where('participants', 'array-contains', auth.currentUser.uid)
    );
    
    const conversationsSnapshot = await getDocs(conversationsQuery);
    const conversationsList = [];
    
    for (const docSnapshot of conversationsSnapshot.docs) {
      const conversationData = docSnapshot.data();
      // Trouver l'ID de l'autre participant (patient)
      const otherParticipantId = conversationData.participants.find(
        id => id !== auth.currentUser.uid
      );
      
      if (otherParticipantId && !patientsMap.has(otherParticipantId)) {
        // Récupérer les informations du patient
        const patientDoc = await getDoc(doc(db, 'patients', otherParticipantId));
        if (patientDoc.exists()) {
          patientsMap.set(otherParticipantId, {
            id: otherParticipantId,
            ...patientDoc.data()
          });
        }
      }
      
      // Ajouter la conversation à la liste
      if (otherParticipantId) {
        const patient = patientsMap.get(otherParticipantId) || { id: otherParticipantId, nom: "Patient inconnu", prenom: "" };
        conversationsList.push({
          id: docSnapshot.id,
          ...conversationData,
          patient: patient,
          unreadCount: conversationData.unreadBy && 
            conversationData.unreadBy.includes(auth.currentUser.uid) ? 1 : 0
        });
      }
    }
    
    // Mettre à jour l'état des conversations
    setConversations(conversationsList);
    
    // Convertir la Map en tableau pour l'état
    setMessagePatients(Array.from(patientsMap.values()));
    
  } catch (error) {
    console.error("Erreur lors du chargement des patients pour la messagerie:", error);
  }
};

// Charger les patients pour la messagerie quand l'onglet messagerie est actif
useEffect(() => {
  if (activeTab === 'messagerie') {
    loadMessagePatients();
  }
}, [activeTab, patients, rendezvous]);

// Fonction pour charger les messages d'une conversation
const fetchMessages = async (conversationId) => {
  if (!conversationId) return () => {};
  
  setLoadingMessages(true);
  try {
    const messagesQuery = query(
      collection(db, 'conversations', conversationId, 'messages'),
      orderBy('timestamp', 'asc')
    );
    
    const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {
      const messagesList = snapshot.docs.map(docSnapshot => ({
        id: docSnapshot.id,
        ...docSnapshot.data()
      }));
      
      setMessages(messagesList);
      setLoadingMessages(false);
      
      // Marquer les messages comme lus
      markConversationAsRead(conversationId);
      
      // Scroll to bottom
      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    });
    
    return unsubscribe;
  } catch (err) {
    console.error("Erreur lors du chargement des messages:", err);
    setError("Impossible de charger les messages.");
    setLoadingMessages(false);
    return () => {};
  }
};

// Marquer une conversation comme lue
const markConversationAsRead = async (conversationId) => {
  try {
    const conversationRef = doc(db, 'conversations', conversationId);
    const conversationSnapshot = await getDoc(conversationRef);
    
    if (conversationSnapshot.exists()) {
      const data = conversationSnapshot.data();
      if (data.unreadBy && data.unreadBy.includes(auth.currentUser.uid)) {
        // Retirer l'ID du médecin de unreadBy
        await updateDoc(conversationRef, {
          unreadBy: data.unreadBy.filter(id => id !== auth.currentUser.uid)
        });
        
        // Mettre à jour localement
        setConversations(prevConversations => 
          prevConversations.map(conv => 
            conv.id === conversationId ? {...conv, unreadCount: 0} : conv
          )
        );
      }
    }
  } catch (err) {
    console.error("Erreur lors du marquage de la conversation comme lue:", err);
  }
};

// Fonction pour gérer le changement de fichier
const handleMessageFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  setAttachmentFile(file);
};

// Fonction pour démarrer l'enregistrement vocal
const startRecording = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    const chunks = [];

    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        chunks.push(e.data);
      }
    };

    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: 'audio/webm' });
      setAudioBlob(blob);
      // Arrêter tous les tracks du stream
      stream.getTracks().forEach(track => track.stop());
    };

    // Démarrer l'enregistrement
    recorder.start();
    setMediaRecorder(recorder);
    setIsRecording(true);
    
    // Démarrer le timer
    const timer = setInterval(() => {
      setRecordingTime(prev => prev + 1);
    }, 1000);
    setRecordingTimer(timer);
    
  } catch (error) {
    console.error("Erreur lors de l'accès au microphone:", error);
  }
};

// Fonction pour arrêter l'enregistrement vocal
const stopRecording = () => {
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop();
    setIsRecording(false);
    
    // Arrêter le timer
    if (recordingTimer) {
      clearInterval(recordingTimer);
      setRecordingTimer(null);
    }
  }
};

// Fonction pour annuler l'enregistrement
const cancelRecording = () => {
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop();
  }
  
  setIsRecording(false);
  setAudioBlob(null);
  setRecordingTime(0);
  
  if (recordingTimer) {
    clearInterval(recordingTimer);
    setRecordingTimer(null);
  }
};

// Fonction pour supprimer le fichier attaché
const removeAttachment = () => {
  setAttachmentFile(null);
};

// Fonction pour supprimer l'audio enregistré
const removeAudio = () => {
  setAudioBlob(null);
  setRecordingTime(0);
};

// Fonction formatant le temps d'enregistrement
const formatRecordingTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

const sendMessage = async (e) => {
  e.preventDefault();
  
  if ((!newMessage.trim() && !attachmentFile && !audioBlob) || !selectedConversation || sendingMessage) {
    return;
  }
  
  setSendingMessage(true);
  try {
    const messageData = {
      text: newMessage.trim(),
      senderId: auth.currentUser.uid,
      senderName: `${medecinData?.titre || "Dr"} ${medecinData?.nom}`,
      timestamp: serverTimestamp(),
      read: false
    };
    
    // Si un fichier est attaché, l'uploader d'abord vers Cloudinary
    if (attachmentFile) {
      const formData = new FormData();
      formData.append('file', attachmentFile);
      formData.append('upload_preset', 'fichiers');
      formData.append('folder', `conversations/${selectedConversation.id}`);
      
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/dodsr1s0d/upload`,
        {
          method: 'POST',
          body: formData,
        }
      );
      
      const data = await response.json();
      
      if (response.ok) {
        messageData.attachment = {
          url: data.secure_url,
          name: attachmentFile.name,
          type: attachmentFile.type,
          size: attachmentFile.size,
          publicId: data.public_id
        };
      } else {
        console.error("Erreur lors de l'upload du fichier vers Cloudinary:", data);
        setError("Erreur lors de l'upload du fichier. Veuillez réessayer.");
        setSendingMessage(false);
        return;
      }
    }
    
    // Si un enregistrement audio est présent, l'uploader vers Cloudinary
    if (audioBlob) {
      const fileName = `audio_${Date.now()}.webm`;
      const audioFile = new File([audioBlob], fileName, { type: 'audio/webm' });
      
      const formData = new FormData();
      formData.append('file', audioFile);
      formData.append('upload_preset', 'fichiers');
      formData.append('folder', `conversations/${selectedConversation.id}`);
      formData.append('resource_type', 'video'); // Pour les fichiers audio
      
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/dodsr1s0d/upload`,
        {
          method: 'POST',
          body: formData,
        }
      );
      
      const data = await response.json();
      
      if (response.ok) {
        messageData.audioAttachment = {
          url: data.secure_url,
          name: fileName,
          type: 'audio/webm',
          duration: recordingTime,
          publicId: data.public_id
        };
      } else {
        console.error("Erreur lors de l'upload de l'audio vers Cloudinary:", data);
        setError("Erreur lors de l'upload de l'audio. Veuillez réessayer.");
        setSendingMessage(false);
        return;
      }
    }
    
    // Ajouter le message à la collection
    await addDoc(collection(db, 'conversations', selectedConversation.id, 'messages'), messageData);
    
    // Mettre à jour la conversation avec le dernier message
    const conversationRef = doc(db, 'conversations', selectedConversation.id);
    await updateDoc(conversationRef, {
      lastMessage: messageData.text || (attachmentFile ? "Pièce jointe" : "Note vocale"),
      lastMessageAt: serverTimestamp(),
      // Marquer comme non lu pour le patient
      unreadBy: [selectedConversation.patient.id]
    });
    
    // Réinitialiser les champs
    setNewMessage('');
    setAttachmentFile(null);
    setAudioBlob(null);
    setRecordingTime(0);
    
  } catch (err) {
    console.error("Erreur lors de l'envoi du message:", err);
    setError("Erreur lors de l'envoi du message. Veuillez réessayer.");
  } finally {
    setSendingMessage(false);
  }
};


// Créer ou sélectionner une conversation avec un patient
const startConversationWithPatient = async (patient) => {
  try {
    // Vérifier si une conversation existe déjà
    const existingConvQuery = query(
      collection(db, 'conversations'),
      where('participants', 'in', [[auth.currentUser.uid, patient.id].sort(), [patient.id, auth.currentUser.uid].sort()])
    );
    
    const existingConvSnapshot = await getDocs(existingConvQuery);
    
    if (!existingConvSnapshot.empty) {
      // Une conversation existe déjà, la sélectionner
      const existingConvDoc = existingConvSnapshot.docs[0];
      const existingConvData = existingConvDoc.data();
      
      setSelectedConversation({
        id: existingConvDoc.id,
        ...existingConvData,
        patient: patient
      });
      
      // Charger les messages de cette conversation
      const unsubscribe = await fetchMessages(existingConvDoc.id);
      return () => {
        if (typeof unsubscribe === 'function') unsubscribe();
      };
    }
    
    // Créer une nouvelle conversation
    const newConversationRef = await addDoc(collection(db, 'conversations'), {
      participants: [auth.currentUser.uid, patient.id].sort(),
      createdAt: serverTimestamp(),
      lastMessageAt: serverTimestamp(),
      lastMessage: "",
      unreadBy: []
    });
    
    // Sélectionner la nouvelle conversation
    setSelectedConversation({
      id: newConversationRef.id,
      participants: [auth.currentUser.uid, patient.id].sort(),
      patient: patient,
      lastMessage: "",
      unreadCount: 0
    });
    
    // Charger les messages (vides pour l'instant)
    const unsubscribe = await fetchMessages(newConversationRef.id);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
    
  } catch (err) {
    console.error("Erreur lors de la création de la conversation:", err);
    return () => {};
  }
};

// Charger les messages lorsqu'une conversation est sélectionnée
useEffect(() => {
  let unsubscribeFunction = null;
  
  if (selectedConversation) {
    const loadMessages = async () => {
      unsubscribeFunction = await fetchMessages(selectedConversation.id);
    };
    
    loadMessages();
  }
  
  return () => {
    if (typeof unsubscribeFunction === 'function') {
      unsubscribeFunction();
    }
  };
}, [selectedConversation?.id]);

// Filtrer les patients pour la messagerie selon la recherche
const filteredMessagePatients = useMemo(() => {
  return messagePatients.filter(patient => {
    const fullName = `${patient.prenom} ${patient.nom}`.toLowerCase();
    return fullName.includes(searchPatientTerm.toLowerCase());
  });
}, [messagePatients, searchPatientTerm]);



useEffect(() => {
  if (!auth.currentUser?.uid) return;
  
  // Créer une requête pour récupérer les conversations avec des messages non lus
  const unreadConversationsQuery = query(
    collection(db, 'conversations'),
    where("unreadBy", "array-contains", auth.currentUser.uid)
  );
  
  // Écouter les changements
  const unsubscribe = onSnapshot(unreadConversationsQuery, (snapshot) => {
    setUnreadMessagesCount(snapshot.docs.length);
    
    // Si des conversations non lues sont détectées et que l'utilisateur n'est pas sur l'onglet messagerie
    if (snapshot.docs.length > 0 && activeTab !== 'messagerie') {
      // Ajouter une notification visuelle ou sonore ici si nécessaire
      const audio = new Audio('/notification-sound.mp3'); // Assurez-vous que ce fichier existe
      audio.play().catch(e => console.log("Lecture audio impossible:", e));
    }
  });
  
  return () => unsubscribe();
}, [auth.currentUser, activeTab]);

// Au début de votre composant ou dans un useEffect
useEffect(() => {
  // S'assurer que window.bootstrap existe
  if (typeof window !== 'undefined' && window.bootstrap) {
    // Bootstrap est disponible
  } else {
    console.error("Bootstrap n'est pas disponible globalement");
  }
}, []);
// Ajoutez ceci à la fin de vos useEffects
useEffect(() => {
  const handleViewPatientEvent = (e) => {
    handleViewDetails('patient', e.detail);
  };
  
  const handleViewRdvEvent = (e) => {
    handleViewDetails('rdv', e.detail);
  };
  
  // Ajouter les écouteurs d'événements
  document.addEventListener('viewPatient', handleViewPatientEvent);
  document.addEventListener('viewRdv', handleViewRdvEvent);
  
  // Nettoyer les écouteurs à la destruction du composant
  return () => {
    document.removeEventListener('viewPatient', handleViewPatientEvent);
    document.removeEventListener('viewRdv', handleViewRdvEvent);
  };
}, []);

  const [filtreDate, setFiltreDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  });
  const [filtreStatut, setFiltreStatut] = useState('tous');
  const [filtreStructure, setFiltreStructure] = useState('');
  const [viewMode, setViewMode] = useState('calendar');
  
  // Gestion de la taille de l'écran
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
      if (window.innerWidth < 999) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const setupAffiliatedStructuresListener = (medecinId) => {
    // Écouter les changements dans le document du médecin pour les affiliations multiples
    const medecinDocRef = doc(db, 'medecins', medecinId);
    
    return onSnapshot(medecinDocRef, async (docSnapshot) => {
      if (!docSnapshot.exists()) {
        setAffiliatedStructures([]);
        return;
      }
      
      const medecinData = docSnapshot.data();
      const affiliatedStructuresData = medecinData.affiliatedStructures || [];
      
      // Récupérer les détails des structures depuis les affiliations multiples
      const structuresData = [];
      for (const affiliation of affiliatedStructuresData) {
        if (affiliation.status === 'active') {
          try {
            const structureDoc = await getDoc(doc(db, 'structures', affiliation.structureId));
            if (structureDoc.exists()) {
              structuresData.push({
                id: affiliation.structureId,
                ...structureDoc.data(),
                affiliationDate: affiliation.affiliationDate
              });
            }
          } catch (error) {
            console.error(`Erreur lors de la récupération de la structure ${affiliation.structureId}:`, error);
          }
        }
      }
      
      // Fallback: si pas d'affiliations multiples, utiliser l'ancien système
      if (structuresData.length === 0 && medecinData.structureId) {
        try {
          const structureDoc = await getDoc(doc(db, 'structures', medecinData.structureId));
          if (structureDoc.exists()) {
            structuresData.push({
              id: medecinData.structureId,
              ...structureDoc.data(),
              affiliationDate: medecinData.structureAffiliationDate
            });
          }
        } catch (error) {
          console.error(`Erreur lors de la récupération de la structure principale ${medecinData.structureId}:`, error);
        }
      }
      
      console.log("Structures affiliées chargées:", structuresData);
      setAffiliatedStructures(structuresData);
    });
  };


  // Écouteur pour les demandes d'affiliation en attente
  const setupPendingAffiliationsListener = (medecinId) => {
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("status", "==", "pending")
    );
    
    return onSnapshot(affiliationsQuery, async (snapshot) => {
      try {
        const requests = [];
        const previousLength = pendingAffiliations.length;
        
        for (const docRef of snapshot.docs) {
          const requestData = docRef.data();
          // Récupérer les informations de la structure
          const structureDoc = await getDoc(doc(db, 'structures', requestData.structureId));
          
          if (structureDoc.exists()) {
            requests.push({
              id: docRef.id,
              ...requestData,
              structureName: structureDoc.data().nom
            });
          }
        }
        
        setPendingAffiliations(requests);
        
        // Si de nouvelles demandes sont arrivées et que l'utilisateur n'est pas sur l'onglet affiliations
        if (requests.length > previousLength && activeTab !== 'affiliations') {
          // Notification sonore
          const audio = new Audio('/notification-sound.mp3');
          audio.play().catch(e => console.log("Lecture audio impossible:", e));
          
          // Afficher un message temporaire
          setMessage(`Vous avez ${requests.length} demande(s) d'affiliation en attente`);
          setTimeout(() => {
            if (message === `Vous avez ${requests.length} demande(s) d'affiliation en attente`) {
              setMessage('');
            }
          }, 5000);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes d'affiliation:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des demandes d'affiliation:", error);
    });
  };

  // Écouteur pour les demandes d'affiliation rejetées
  const setupRejectedAffiliationsListener = (medecinId) => {
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("status", "==", "rejected")
    );
    
    return onSnapshot(affiliationsQuery, async (snapshot) => {
      try {
        const requests = [];
        
        snapshot.forEach((doc) => {
          requests.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setRejectedAffiliations(requests);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes rejetées:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des demandes rejetées:", error);
    });
  };

  // Écouteur pour toutes les structures
  const setupAllStructuresListener = () => {
    return onSnapshot(collection(db, 'structures'), (snapshot) => {
      try {
        const structuresData = [];
        const specialitesSet = new Set();
        
        snapshot.forEach((doc) => {
          const structureData = {
            id: doc.id,
            ...doc.data()
          };
          
          // Add check for specialites array
          if (Array.isArray(structureData.specialites)) {
            structureData.specialites.forEach(spec => specialitesSet.add(spec));
          } else {
            // Initialize as empty array if not present or not an array
            structureData.specialites = [];
          }
          
          structuresData.push(structureData);
        });
        
        setStructures(structuresData);
        setAllStructures(structuresData);
        setSpecialites(Array.from(specialitesSet).sort());
      } catch (error) {
        console.error("Erreur lors de la récupération des structures:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des structures:", error);
    });
  };

  // Écouteur pour les rendez-vous
  const setupRendezvousListener = (medecinId) => {
    const rdvQuery = query(
      collection(db, 'rendezvous'),
      where("medecinId", "==", medecinId)
    );
    
    return onSnapshot(rdvQuery, (snapshot) => {
      try {
        const rdvData = [];
        snapshot.forEach((doc) => {
          // Normaliser la date lors du chargement
          const rdv = doc.data();
          if (rdv.date) {
            // S'assurer que la date est correctement formatée (YYYY-MM-DD)
            const dateObj = new Date(rdv.date);
            if (!isNaN(dateObj.getTime())) {
              rdv.date = formatDateString(dateObj);
            }
          }
          rdvData.push({ id: doc.id, ...rdv });
        });
        
        setRendezvous(rdvData);
      } catch (error) {
        console.error("Erreur lors de la récupération des rendez-vous:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des rendez-vous:", error);
    });
  };

  // Écouteur pour les demandes d'affiliation envoyées
  const setupSentAffiliationRequestsListener = (medecinId) => {
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("status", "in", ["pending", "rejected"])
    );
    
    return onSnapshot(affiliationsQuery, (snapshot) => {
      try {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setSentAffiliationRequests(requests);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes d'affiliation:", error);
      }
    }, (error) => {
      console.error("Erreur d'écoute des demandes d'affiliation:", error);
    });
  };


  // Écouteur pour les patients basé sur les rendez-vous
  useEffect(() => {
    if (rendezvous.length > 0) {
      const uniquePatientIds = new Set();
      rendezvous.forEach(rdv => {
        if (rdv.patientId) {
          uniquePatientIds.add(rdv.patientId);
        }
      });
      
      if (uniquePatientIds.size === 0) {
        setPatients([]);
        return;
      }
      
      // Créer un tableau de promesses pour récupérer les données des patients
      const fetchPatientPromises = Array.from(uniquePatientIds).map(async (patientId) => {
        try {
          const patientDoc = await getDoc(doc(db, 'patients', patientId));
          if (patientDoc.exists()) {
            return {
              id: patientId,
              ...patientDoc.data()
            };
          }
          return null;
        } catch (error) {
          console.error(`Erreur lors de la récupération du patient ${patientId}:`, error);
          return null;
        }
      });
      
      // Exécuter toutes les promesses
      Promise.all(fetchPatientPromises)
        .then(patientsData => {
          // Filtrer les valeurs null
          const validPatients = patientsData.filter(patient => patient !== null);
          setPatients(validPatients);
        })
        .catch(error => {
          console.error("Erreur lors de la récupération des patients:", error);
        });
    } else {
      setPatients([]);
    }
  }, [rendezvous]);

  // Filtrer les structures selon la recherche et la spécialité
  const filteredStructures = useMemo(() => {
    return allStructures.filter(structure => {
      const matchesSearch = searchStructure === '' || 
        structure.nom.toLowerCase().includes(searchStructure.toLowerCase()) ||
        (structure.description && structure.description.toLowerCase().includes(searchStructure.toLowerCase()));
      
      const matchesSpecialite = filtreSpecialite === '' || 
        (structure.specialites && structure.specialites.includes(filtreSpecialite));
      
      return matchesSearch && matchesSpecialite;
    });
  }, [allStructures, searchStructure, filtreSpecialite]);

  // Fonctions générales
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/auth');
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    }
  };
// Dans handleUpdate


const handleUpdate = async () => {
  try {
    const user = auth.currentUser;
    
    // Convertir les disponibilités du format formulaire vers le format à enregistrer
    const disponibilitesAEnregistrer = [];
    Object.entries(form.disponibilites).forEach(([jour, dispo]) => {
      if (dispo.actif) {
        dispo.creneaux.forEach(creneau => {
          disponibilitesAEnregistrer.push({
            jour: jour.charAt(0).toUpperCase() + jour.slice(1),
            heureDebut: creneau.debut,
            heureFin: creneau.fin,
            structureId: creneau.structureId || ''
          });
        });
      }
    });
    
    console.log("Disponibilités à enregistrer:", disponibilitesAEnregistrer);
    
    // Mettre à jour le document du médecin
    await updateDoc(doc(db, "medecins", user.uid), {
      ...form,
      disponibilites: disponibilitesAEnregistrer,
      updatedAt: new Date()
    });
    
    setMessage("Profil mis à jour avec succès.");
    setTimeout(() => setMessage(""), 3000);
  } catch (error) {
    setMessage(`Erreur: ${error.message}`);
  }
};




  const handlePasswordChange = async () => {
    try {
      const user = auth.currentUser;
      await updatePassword(user, newPassword);
      setMessage('Mot de passe mis à jour avec succès.');
      setNewPassword('');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('disponibilites.')) {
      const [_, jour, prop] = name.split('.');
      setForm(prev => ({
        ...prev,
        disponibilites: {
          ...prev.disponibilites,
          [jour]: {
            ...prev.disponibilites[jour],
            [prop]: type === 'checkbox' ? checked : value
          }
        }
      }));
    } else {
      setForm({ ...form, [name]: value });
    }
  };

// 1. Modifions la fonction qui récupère les données du médecin
// Cette fonction doit être appelée après la récupération des structures affiliées

useEffect(() => {
  const fetchMedecinData = async () => {
    if (!auth.currentUser || affiliatedStructures.length === 0) return;
    
    try {
      const medecinRef = doc(db, "medecins", auth.currentUser.uid);
      const medecinDoc = await getDoc(medecinRef);
      
      if (medecinDoc.exists()) {
        const data = medecinDoc.data();
        setMedecinData(data);
        
        // Initialiser les disponibilités avec la structure pour créneaux multiples
        const disponibilites = {};
        ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'].forEach(jour => {
          disponibilites[jour] = {
            actif: false,
            creneaux: [{ debut: '08:00', fin: '18:00', structureId: '' }]
          };
        });
        
        // Si les disponibilités existent déjà dans les données du médecin
        if (data.disponibilites) {
          if (Array.isArray(data.disponibilites)) {
            // Format ancien - tableau de disponibilités
            console.log("Format tableau détecté pour les disponibilités");
            
            // Regrouper les disponibilités par jour
            const dispoParJour = {};
            data.disponibilites.forEach(dispo => {
              const jour = dispo.jour.toLowerCase();
              if (!dispoParJour[jour]) {
                dispoParJour[jour] = [];
              }
              dispoParJour[jour].push({
                debut: dispo.heureDebut || '08:00',
                fin: dispo.heureFin || '18:00',
                structureId: dispo.structureId || ''
              });
            });
            
            // Mettre à jour les disponibilités formatées
            Object.entries(dispoParJour).forEach(([jour, creneaux]) => {
              if (disponibilites[jour]) {
                disponibilites[jour] = {
                  actif: true,
                  creneaux: creneaux
                };
              }
            });
          } else if (typeof data.disponibilites === 'object') {
            // Format objet - vérifier s'il contient déjà des créneaux multiples
            Object.entries(data.disponibilites).forEach(([jour, dispo]) => {
              if (disponibilites[jour]) {
                if (dispo.creneaux) {
                  // Format déjà avec créneaux multiples
                  disponibilites[jour] = dispo;
                } else if (dispo.actif) {
                  // Format ancien avec un seul créneau
                  disponibilites[jour] = {
                    actif: true,
                    creneaux: [{
                      debut: dispo.debut || '08:00',
                      fin: dispo.fin || '18:00',
                      structureId: dispo.structureId || ''
                    }]
                  };
                }
              }
            });
          }
        }
        
        // Mettre à jour le formulaire avec les disponibilités correctes
        setForm({
          ...data,
          disponibilites
        });
        
        // Débogage - vérifier les structures associées
        console.log("Disponibilités chargées:", disponibilites);
        console.log("Structures affiliées disponibles:", affiliatedStructures);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données du médecin:", error);
    }
  };
  
  fetchMedecinData();
}, [auth.currentUser, affiliatedStructures]);


// Fonction pour gérer les changements dans les disponibilités
const handleDisponibiliteChange = (jour, field, value, index = 0) => {
  if (field === "actif") {
    setForm({
      ...form,
      disponibilites: {
        ...form.disponibilites,
        [jour]: {
          ...form.disponibilites[jour],
          actif: !form.disponibilites[jour].actif,
        },
      },
    });
  } else {
    const updatedCreneaux = [...form.disponibilites[jour].creneaux];
    updatedCreneaux[index] = {
      ...updatedCreneaux[index],
      [field]: value,
    };
    
    setForm({
      ...form,
      disponibilites: {
        ...form.disponibilites,
        [jour]: {
          ...form.disponibilites[jour],
          creneaux: updatedCreneaux,
        },
      },
    });
  }
};

// Fonction pour ajouter un nouveau créneau à un jour
const addCreneau = (jour) => {
  const updatedCreneaux = [
    ...form.disponibilites[jour].creneaux,
    { debut: "08:00", fin: "18:00", structureId: "" }
  ];
  
  setForm({
    ...form,
    disponibilites: {
      ...form.disponibilites,
      [jour]: {
        ...form.disponibilites[jour],
        creneaux: updatedCreneaux,
      },
    },
  });
};

// Fonction pour supprimer un créneau
const removeCreneau = (jour, index) => {
  if (form.disponibilites[jour].creneaux.length <= 1) {
    return; // Garder au moins un créneau
  }
  
  const updatedCreneaux = form.disponibilites[jour].creneaux.filter((_, i) => i !== index);
  
  setForm({
    ...form,
    disponibilites: {
      ...form.disponibilites,
      [jour]: {
        ...form.disponibilites[jour],
        creneaux: updatedCreneaux,
      },
    },
  });
};



  // Fonction pour basculer l'état du menu latéral
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleRequestAffiliation = async (structureId) => {
    try {
      const user = auth.currentUser;
      
      // Vérifier si une demande existe déjà
      const existingQuery = query(
        collection(db, 'affiliationRequests'),
        where("medecinId", "==", user.uid),
        where("structureId", "==", structureId)
      );
      
      const existingSnapshot = await getDocs(existingQuery);
      
      // Si des demandes existent, les supprimer d'abord
      const deletePromises = [];
      existingSnapshot.forEach((doc) => {
        deletePromises.push(deleteDoc(doc.ref));
      });
      
      // Attendre que toutes les suppressions soient terminées
      if (deletePromises.length > 0) {
        await Promise.all(deletePromises);
        console.log("Anciennes demandes d'affiliation supprimées");
      }
      
      // Créer une nouvelle demande
      const structure = structures.find(s => s.id === structureId);
      await addDoc(collection(db, 'affiliationRequests'), {
        medecinId: user.uid,
        medecinNom: `${medecinData.titre || "Dr"} ${medecinData.prenom} ${medecinData.nom}`,
        structureId: structureId,
        structureName: structure.nom,
        status: 'pending',
        createdAt: new Date(),
        updatedAt: new Date()
      });
      
      
      setMessage("Demande d'affiliation envoyée avec succès.");
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };
  

  // Fonction pour annuler une demande d'affiliation
  const handleCancelRequest = async (requestId) => {
    try {
      await deleteDoc(doc(db, 'affiliationRequests', requestId));
      
      setMessage("Demande d'affiliation annulée.");
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };


  // Fonction pour vérifier si une demande d'affiliation peut être faite
const canRequestAffiliation = (structureId) => {
  // Vérifier si déjà affilié
  const isAffiliated = affiliatedStructures.some(s => s.id === structureId);
  
  // Vérifier si une demande est en attente
  const hasPendingRequest = sentAffiliationRequests.some(req => 
    req.structureId === structureId && req.status === "pending"
  );
  
  // Vérifier si une demande a été rejetée récemment (moins de 30 jours)
  const hasRecentRejection = rejectedAffiliations.some(req => {
    if (req.structureId !== structureId) return false;
    
    // Vérifier si le rejet date de moins de 30 jours
    const rejectionDate = req.updatedAt?.toDate() || new Date();
    const daysSinceRejection = (new Date() - rejectionDate) / (1000 * 60 * 60 * 24);
    return daysSinceRejection < 30;
  });
  
  // Vérifier l'historique des désaffiliations
  const [wasRecentlyDisaffiliated, setWasRecentlyDisaffiliated] = useState(false);
  
  useEffect(() => {
    const checkDisaffiliationHistory = async () => {
      try {
        const historyQuery = query(
          collection(db, 'affiliationHistory'),
          where("medecinId", "==", auth.currentUser.uid),
          where("structureId", "==", structureId),
          where("action", "==", "removed")
        );
        
        const snapshot = await getDocs(historyQuery);
        let recentDisaffiliation = false;
        
        snapshot.forEach(doc => {
          const data = doc.data();
          const disaffiliationDate = data.timestamp?.toDate() || new Date();
          const daysSinceDisaffiliation = (new Date() - disaffiliationDate) / (1000 * 60 * 60 * 24);
          
          if (daysSinceDisaffiliation < 7) { // Période de "refroidissement" de 7 jours
            recentDisaffiliation = true;
          }
        });
        
        setWasRecentlyDisaffiliated(recentDisaffiliation);
      } catch (error) {
        console.error("Erreur lors de la vérification de l'historique de désaffiliation:", error);
      }
    };
    
    if (structureId) {
      checkDisaffiliationHistory();
    }
  }, [structureId]);
  
  return !isAffiliated && !hasPendingRequest && !hasRecentRejection && !wasRecentlyDisaffiliated;
};



  // Fonction pour annuler une demande d'affiliation
  const handleCancelAffiliation = async (affiliationId) => {
    try {
      await deleteDoc(doc(db, 'affiliationRequests', affiliationId));
      
      setMessage("Demande d'affiliation annulée.");
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };  

// Fonction pour se désaffilier
const handleDesaffiliation = async (structureId) => {
  // Demander confirmation avant de procéder
  if (!window.confirm("Êtes-vous sûr de vouloir vous désaffilier de cette structure ? Vous ne pourrez plus recevoir de rendez-vous de sa part.")) {
    return;
  }
  
  try {
    setLoading(true);
    const user = auth.currentUser;
    const medecinId = user.uid;
    
    // 1. Mettre à jour le système d'affiliations multiples
    const medecinRef = doc(db, 'medecins', medecinId);
    const medecinDoc = await getDoc(medecinRef);
    
    if (!medecinDoc.exists()) {
      setMessage("Profil médecin introuvable");
      setLoading(false);
      return;
    }
    
    const medecinData = medecinDoc.data();
    const currentAffiliations = medecinData.affiliatedStructures || [];
    
    // Retirer l'affiliation spécifique
    const updatedAffiliations = currentAffiliations.filter(
      aff => aff.structureId !== structureId
    );
    
    // Préparer les données de mise à jour
    const updateData = {
      affiliatedStructures: updatedAffiliations
    };
    
    // Gérer la compatibilité avec l'ancien système
    if (medecinData.structureId === structureId) {
      if (updatedAffiliations.length > 0) {
        // S'il reste d'autres structures, prendre la première comme structure principale
        const newPrimaryStructure = updatedAffiliations[0];
        updateData.structureId = newPrimaryStructure.structureId;
        updateData.structureNom = newPrimaryStructure.structureNom;
        updateData.structureAffiliationDate = newPrimaryStructure.affiliationDate;
        updateData.isAffiliated = true;
      } else {
        // Plus aucune structure, réinitialiser
        updateData.structureId = null;
        updateData.structureAffiliationDate = null;
        updateData.structureNom = '';
        updateData.isAffiliated = false;
      }
    }
    
    await updateDoc(medecinRef, updateData);
    
    // 2. Supprimer aussi de l'ancien système (affiliationRequests)
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", medecinId),
      where("structureId", "==", structureId),
      where("status", "in", ["accepted"])
    );
    
    const querySnapshot = await getDocs(affiliationsQuery);
    if (!querySnapshot.empty) {
      const affiliationId = querySnapshot.docs[0].id;
      console.log("Suppression de l'affiliation:", affiliationId);
      await deleteDoc(doc(db, 'affiliationRequests', affiliationId));
    }
    
    // 3. Ajouter dans l'historique
    await addDoc(collection(db, 'affiliationHistory'), {
      medecinId: medecinId,
      structureId: structureId,
      action: 'removed',
      timestamp: Timestamp.now()
    });
    
    // 4. Mettre à jour immédiatement l'UI
    setAffiliatedStructures(prev => prev.filter(s => s.id !== structureId));
    
    setMessage("Désaffiliation effectuée avec succès.");
    
    // Faire disparaître le message après 3 secondes
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de la désaffiliation:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};


  // Fonctions pour la vue calendrier
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const getMonthData = useCallback(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    
    const days = [];
    
    // Ajouter les jours du mois précédent pour compléter la première semaine
    const prevMonthDays = getDaysInMonth(year, month - 1);
    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(year, month - 1, prevMonthDays - i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateString = formatDateString(date);
      
      // Vérifier les rendez-vous pour cette date
      const dayEvents = rendezvous.filter(rdv => {
        return rdv.date === dateString && 
          (filtreStatut === 'tous' || rdv.statut === filtreStatut) &&
          (filtreStructure === '' || rdv.structureId === filtreStructure);
      });
      
      days.push({
        date: date,
        isCurrentMonth: true,
        hasEvents: dayEvents.length > 0,
        events: dayEvents,
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois suivant pour compléter la dernière semaine
    const totalDaysToShow = 42; // 6 semaines
    const remainingDays = totalDaysToShow - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    return days;
  }, [currentMonth, rendezvous, filtreStatut, filtreStructure]);

  const formatDateString = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };



const handleDateClick = (day) => {
  if (day.hasEvents) {
    setSelectedDate(day);
    handleViewDetails('date-events', day);
  }
};
  
  
  const handleMobileDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      handleViewDetails('date-events', day);
    }
  };
  

  const handleRdvClick = (rdv) => {
    handleViewDetails('rdv', rdv);
  };

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  // Fonction pour obtenir les informations d'une structure par son ID
  const getStructureById = (structureId) => {
    return structures.find(structure => structure.id === structureId) || { nom: 'Structure inconnue' };
  };

  // Fonction pour obtenir les informations d'un patient par son ID
  const getPatientById = (patientId) => {
    return patients.find(patient => patient.id === patientId);
  };

  // Fonction pour afficher les détails d'un patient
  const handleViewPatient = (patientId) => {
    const patient = getPatientById(patientId);
    if (patient) {
      handleViewDetails('patient', patient);
    }
  };

  // Fonction pour calculer l'âge à partir de la date de naissance
  const calculateAge = (dateNaissance) => {
    if (!dateNaissance) return 'N/A';
    
    const birthDate = new Date(dateNaissance);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  };

  // Filtrer les rendez-vous
  const filteredRendezvous = rendezvous.filter(rdv => {
    let matchesDate = true;
    let matchesStatut = true;
    let matchesStructure = true;
    
    if (filtreDate) {
      matchesDate = rdv.date === filtreDate;
    }
    
    if (filtreStatut !== 'tous') {
      matchesStatut = rdv.statut === filtreStatut;
    }
    
    if (filtreStructure !== '') {
      matchesStructure = rdv.structureId === filtreStructure;
    }
    
    return matchesDate && matchesStatut && matchesStructure;
  });

  // Trier les rendez-vous par date et heure
  filteredRendezvous.sort((a, b) => {
    if (a.date !== b.date) {
      return new Date(a.date) - new Date(b.date);
    }
    return a.heure.localeCompare(b.heure);
  });

  // Interface mobile
  const handleMobileTabChange = (tab) => {
    setActiveTab(tab);
    setShowMobileMenu(false);
    setMobileDetailView(null);
  };

  const handleMobileDetailView = (type, item) => {
    handleViewDetails(type, item);
  };
  

  const handleBackToList = () => {
    setMobileDetailView(null);
  };

  // Fonction pour rafraîchir les affiliations
  const refreshAffiliations = async () => {
    try {
      setLoading(true);
      setMessage("Rafraîchissement des données...");
      
      // Les écouteurs en temps réel mettront automatiquement à jour les données
      // Cette fonction est conservée pour permettre un rafraîchissement manuel si nécessaire
      
      setMessage("Données mises à jour avec succès");
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("Erreur lors du rafraîchissement des affiliations:", error);
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };


  // Écouteur pour l'historique des désaffiliations
const setupDisaffiliationHistoryListener = (medecinId) => {
  const historyQuery = query(
    collection(db, 'affiliationHistory'),
    where("medecinId", "==", medecinId),
    where("action", "==", "removed")
  );
  
  return onSnapshot(historyQuery, (snapshot) => {
    try {
      const history = [];
      snapshot.forEach((doc) => {
        history.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      setDisaffiliationHistory(history);
    } catch (error) {
      console.error("Erreur lors de la récupération de l'historique des désaffiliations:", error);
    }
  }, (error) => {
    console.error("Erreur d'écoute de l'historique des désaffiliations:", error);
  });
};

// Fonction pour vérifier si une structure a récemment désaffilié le médecin
const wasRecentlyDisaffiliated = (structureId) => {
  return disaffiliationHistory.some(history => {
    if (history.structureId !== structureId) return false;
    
    // Vérifier si la désaffiliation date de moins de 7 jours
    const disaffiliationDate = history.timestamp?.toDate() || new Date();
    const daysSinceDisaffiliation = (new Date() - disaffiliationDate) / (1000 * 60 * 60 * 24);
    return daysSinceDisaffiliation < 1; // Période de "refroidissement" de 1 jour
  });
};

// Fonction pour nettoyer les demandes d'affiliation obsolètes
const cleanupAffiliationRequests = async () => {
  try {
    const user = auth.currentUser;
    if (!user) return;
    
    // Récupérer toutes les demandes d'affiliation pour ce médecin
    const affiliationsQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid)
    );
    
    const querySnapshot = await getDocs(affiliationsQuery);
    
    // Vérifier chaque demande
    for (const docSnap of querySnapshot.docs) {
      const request = docSnap.data();
      
      // Si la structure est dans la liste des structures affiliées,
      // mais que la demande n'est pas "accepted", la supprimer
      const isAffiliated = affiliatedStructures.some(s => s.id === request.structureId);
      if (isAffiliated && request.status !== "accepted") {
        await deleteDoc(docSnap.ref);
        console.log(`Demande obsolète supprimée: ${docSnap.id}`);
      }
      
      // Si la structure n'est pas dans la liste des structures affiliées,
      // mais que la demande est "accepted", la supprimer également
      if (!isAffiliated && request.status === "accepted") {
        await deleteDoc(docSnap.ref);
        console.log(`Demande approuvée obsolète supprimée: ${docSnap.id}`);
      }
    }
    
    console.log("Nettoyage des demandes d'affiliation terminé");
  } catch (error) {
    console.error("Erreur lors du nettoyage des demandes d'affiliation:", error);
  }
};





const handleViewDetails = (type, item) => {
  setDetailsType(type);
  setDetailsItem(item);
  setShowDetails(true);
  
  // Cas spécifiques selon le type
  if (type === 'archive') {
    setArchiveNotes(item.notes || '');
    setArchiveFiles(item.files || []);
  } else if (type === 'rdv') {
    setSelectedRdv(item);
    setNewStatus(item.statut);
  } else if (type === 'patient') {
    setSelectedPatient(item);
  } else if (type === 'backup') {
    setBackupNotes(item.notes || '');
    setBackupFiles(item.files || []);
    setSelectedBackup(item);
  }
};


const startEditStatus = (rdv) => {
  setSelectedRdv(rdv);
  setNewStatus(rdv.statut);
  setEditingStatus(true);
};

// Fonction pour enregistrer le nouveau statut
const saveStatusChange = async () => {
  try {
    if (!selectedRdv) return;
    
    // Mettre à jour dans Firestore
    await updateDoc(doc(db, 'rendezvous', selectedRdv.id), {
      statut: newStatus,
      updatedAt: new Date()
    });
    
    // Mettre à jour l'UI localement
    setRendezvous(prev => prev.map(rdv => 
      rdv.id === selectedRdv.id ? {...rdv, statut: newStatus} : rdv
    ));
    
    setMessage('Statut du rendez-vous mis à jour avec succès');
    setTimeout(() => setMessage(''), 3000);
    
    // Réinitialiser l'état d'édition
    setEditingStatus(false);
    
    // Fermer la modal si ouverte
    const rdvModal = document.getElementById('rdvDetailsModal');
    if (rdvModal) {
      const bsModal = window.bootstrap.Modal.getInstance(rdvModal);
      if (bsModal) bsModal.hide();
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour du statut:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};

// Fonction pour annuler l'édition
const cancelEditStatus = () => {
  setEditingStatus(false);
};

// Fonction pour vérifier les affiliations
const checkAffiliations = async () => {
  try {
    const user = auth.currentUser;
    if (!user) return;
    
    // Vérifier les affiliations approuvées
    const approvedQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid),
      where("status", "==", "approved") // Vérifier avec "approved"
    );
    
    const approvedSnapshot = await getDocs(approvedQuery);
    console.log(`Affiliations approuvées trouvées: ${approvedSnapshot.size}`);
    
    // Vérifier aussi avec "accepted" au cas où
    const acceptedQuery = query(
      collection(db, 'affiliationRequests'),
      where("medecinId", "==", user.uid),
      where("status", "==", "accepted") // Vérifier avec "accepted"
    );
    
    const acceptedSnapshot = await getDocs(acceptedQuery);
    console.log(`Affiliations acceptées trouvées: ${acceptedSnapshot.size}`);
    
    // Afficher les détails pour débogage
    approvedSnapshot.forEach(doc => {
      console.log("Affiliation approuvée:", doc.id, doc.data());
    });
    
    acceptedSnapshot.forEach(doc => {
      console.log("Affiliation acceptée:", doc.id, doc.data());
    });
  } catch (error) {
    console.error("Erreur lors de la vérification des affiliations:", error);
  }
};





  // Vérification de l'authentification et configuration des écouteurs
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          setLoading(true);
          const docRef = doc(db, 'medecins', user.uid);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            const data = docSnap.data();
            setMedecinData(data);
            setForm(data);
            
            console.log("Chargement des données du médecin:", user.uid);
            
            // Configurer les écouteurs
            const unsubscribeAllStructures = setupAllStructuresListener();
            console.log("Écouteur pour toutes les structures configuré");
            
            const unsubscribeRejectedAffiliations = setupRejectedAffiliationsListener(user.uid);
            console.log("Écouteur pour les affiliations rejetées configuré");
            
            const unsubscribePendingAffiliations = setupPendingAffiliationsListener(user.uid);
            console.log("Écouteur pour les affiliations en attente configuré");
            
            const unsubscribeAffiliatedStructures = setupAffiliatedStructuresListener(user.uid);
            console.log("Écouteur pour les structures affiliées configuré");
            
            const unsubscribeRendezvous = setupRendezvousListener(user.uid);
            console.log("Écouteur pour les rendez-vous configuré");
            
            const unsubscribeSentRequests = setupSentAffiliationRequestsListener(user.uid);
            console.log("Écouteur pour les demandes d'affiliation envoyées configuré");
            const unsubscribeBackups = setupBackupsListener(user.uid);

            // Stocker les fonctions de désabonnement
            setUnsubscribeFunctions([
              unsubscribeAllStructures,
              unsubscribeRejectedAffiliations,
              unsubscribePendingAffiliations,
              unsubscribeAffiliatedStructures,
              unsubscribeRendezvous,
              unsubscribeSentRequests,
              unsubscribeBackups,

            ]);
          } else {
            console.error("Aucun document médecin trouvé!");
            navigate('/auth');
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des données:", error);
        } finally {
          setLoading(false);
        }
      } else {
        navigate('/auth');
      }
    });
    
    // Nettoyage lors du démontage du composant
    return () => {
      unsubscribeAuth();
      // Désabonner tous les écouteurs
      unsubscribeFunctions.forEach(unsubscribe => {
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      });
    };
  }, [auth, navigate]);


  const handleManualArchivePatient = async (patient) => {
    try {
      if (!window.confirm(`Êtes-vous sûr de vouloir archiver ${patient.prenom} ${patient.nom} ?`)) {
        return;
      }
      
      // Récupérer les rendez-vous associés à ce patient
      const patientRdvs = rendezvous.filter(rdv => rdv.patientId === patient.id);
      
      // Sauvegarder le patient avec ses rendez-vous
      await savePatientBackup(patient, patientRdvs);
      
      setMessage(`${patient.prenom} ${patient.nom} a été archivé avec succès`);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("Erreur lors de l'archivage manuel du patient:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };
  

  const handleChangeRdvStatus = async (rdvId, newStatus) => {
    try {
      // Récupérer le rendez-vous actuel
      const rdvDoc = await getDoc(doc(db, 'rendezvous', rdvId));
      if (!rdvDoc.exists()) {
        setMessage('Rendez-vous non trouvé');
        return;
      }
      
      const rdvData = {
        id: rdvId,
        ...rdvDoc.data()
      };
      
      // Mettre à jour dans Firestore
      await updateDoc(doc(db, 'rendezvous', rdvId), {
        statut: newStatus,
        updatedAt: new Date()
      });
      
      // Mettre à jour l'UI localement
      setRendezvous(prev => prev.map(rdv => 
        rdv.id === rdvId ? {...rdv, statut: newStatus} : rdv
      ));
      
      // Mettre à jour également dans selectedDate si nécessaire
      if (selectedDate) {
        const updatedEvents = selectedDate.events.map(rdv => 
          rdv.id === rdvId ? {...rdv, statut: newStatus} : rdv
        );
        setSelectedDate({...selectedDate, events: updatedEvents});
      }
      
      // Si le statut est "terminé", archiver automatiquement le patient
      if (newStatus === 'confirmé') {
        const updatedRdv = {
          ...rdvData,
          statut: newStatus
        };
        await archivePatientWhenRdvCompleted(updatedRdv);
      }
      
      setMessage('Statut du rendez-vous mis à jour avec succès');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };
  





const savePatientBackup = async (patient, rdvs = []) => {
  try {
    const backupData = {
      patientData: { ...patient },
      rendezVous: rdvs,
      notes: "",
      files: [],
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      medecinId: auth.currentUser.uid
    };
    
    // Vérifier si une sauvegarde existe déjà pour ce patient
    const existingBackupQuery = query(
      collection(db, 'patientBackups'),
      where("patientData.id", "==", patient.id),
      where("medecinId", "==", auth.currentUser.uid)
    );
    
    const existingBackupSnapshot = await getDocs(existingBackupQuery);
    
    if (existingBackupSnapshot.empty) {
      // Créer une nouvelle sauvegarde
      await addDoc(collection(db, 'patientBackups'), backupData);
      setMessage("Patient sauvegardé avec succès");
    } else {
      // Mettre à jour la sauvegarde existante
      const backupDoc = existingBackupSnapshot.docs[0];
      await updateDoc(doc(db, 'patientBackups', backupDoc.id), {
        patientData: { ...patient },
        rendezVous: [...backupDoc.data().rendezVous, ...rdvs.filter(rdv => 
          !backupDoc.data().rendezVous.some(existingRdv => existingRdv.id === rdv.id)
        )],
        updatedAt: serverTimestamp()
      });
      setMessage("Sauvegarde du patient mise à jour");
    }
    
    setTimeout(() => setMessage(''), 3000);
  } catch (error) {
    console.error("Erreur lors de la sauvegarde du patient:", error);
    setMessage(`Erreur: ${error.message}`);
  }
};


// Écouteur pour les sauvegardes de patients
const setupBackupsListener = (medecinId) => {
  const backupsQuery = query(
    collection(db, 'patientBackups'),
    where("medecinId", "==", medecinId),
    orderBy("updatedAt", "desc")
  );
  
  return onSnapshot(backupsQuery, (snapshot) => {
    try {
      const backupsData = [];
      snapshot.forEach((doc) => {
        backupsData.push({
          id: doc.id,
          ...doc.data(),
          updatedAt: doc.data().updatedAt?.toDate() || new Date()
        });
      });
      
      setBackups(backupsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des sauvegardes:", error);
    }
  });
};


// Fonction pour gérer le changement de fichier
const handleBackupFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setBackupFileToUpload(file);
  }
};

// Fonction pour téléverser un fichier vers Cloudinary
const handleBackupFileUpload = async () => {
  if (!backupFileToUpload || !selectedBackup) return;
  
  try {
    setLoading(true);
    
    // Créer un FormData pour l'upload vers Cloudinary
    const formData = new FormData();
    formData.append('file', backupFileToUpload);
    formData.append('upload_preset', 'fichiers');
    formData.append('folder', `backups/${selectedBackup.id}`);
    
    // Envoyer le fichier à Cloudinary
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/dodsr1s0d/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );
    
    const data = await response.json();
    
    if (response.ok) {
      // Ajouter le fichier à la sauvegarde dans Firestore
      const fileData = {
        id: data.public_id,
        name: backupFileToUpload.name,
        type: backupFileToUpload.type,
        size: backupFileToUpload.size,
        url: data.secure_url,
        uploadedAt: new Date()
      };
      
      const backupRef = doc(db, 'patientBackups', selectedBackup.id);
      await updateDoc(backupRef, {
        files: arrayUnion(fileData),
        updatedAt: serverTimestamp()
      });
      
      // Mettre à jour l'état local
      setBackupFiles([...backupFiles, fileData]);
      setBackupFileToUpload(null);
      setMessage("Fichier téléversé avec succès");
    } else {
      setMessage(`Erreur lors du téléversement: ${data.error?.message || 'Erreur inconnue'}`);
    }
  } catch (error) {
    console.error("Erreur lors du téléversement du fichier:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour télécharger un fichier
const handleDownloadBackupFile = (file) => {
  window.open(file.url, '_blank');
};

// Fonction pour supprimer un fichier
const handleDeleteBackupFile = async (fileId) => {
  if (!selectedBackup) return;
  
  try {
    setLoading(true);
    
    // Supprimer le fichier de Cloudinary
    // Note: Cela nécessite une fonction backend sécurisée car l'API de suppression Cloudinary
    // ne devrait pas être appelée directement depuis le frontend pour des raisons de sécurité
    
    // Mettre à jour Firestore
    const backupRef = doc(db, 'patientBackups', selectedBackup.id);
    const updatedFiles = backupFiles.filter(file => file.id !== fileId);
    
    await updateDoc(backupRef, {
      files: updatedFiles,
      updatedAt: serverTimestamp()
    });
    
    setBackupFiles(updatedFiles);
    setMessage("Fichier supprimé avec succès");
  } catch (error) {
    console.error("Erreur lors de la suppression du fichier:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};


// Fonction pour enregistrer les notes
const handleSaveBackupNotes = async () => {
  if (!selectedBackup) return;
  
  try {
    setLoading(true);
    
    const backupRef = doc(db, 'patientBackups', selectedBackup.id);
    await updateDoc(backupRef, {
      notes: backupNotes,
      updatedAt: serverTimestamp()
    });
    
    setMessage("Notes enregistrées avec succès");
  } catch (error) {
    console.error("Erreur lors de l'enregistrement des notes:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour supprimer une sauvegarde
const handleDeleteBackup = async (backupId) => {
  if (!window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette sauvegarde ?")) {
    return;
  }
  
  try {
    setLoading(true);
    
    // Supprimer la sauvegarde de Firestore
    await deleteDoc(doc(db, 'patientBackups', backupId));
    
    // Mettre à jour l'état local
    setBackups(prevBackups => prevBackups.filter(backup => backup.id !== backupId));
    
    // Réinitialiser la sélection si la sauvegarde supprimée était sélectionnée
    if (selectedBackup && selectedBackup.id === backupId) {
      setSelectedBackup(null);
      setBackupNotes('');
      setBackupFiles([]);
    }
    
    setMessage("Sauvegarde supprimée avec succès");
  } catch (error) {
    console.error("Erreur lors de la suppression de la sauvegarde:", error);
    setMessage(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour archiver automatiquement un patient lorsqu'un rendez-vous est marqué comme terminé
const archivePatientWhenRdvCompleted = async (rdv) => {
  if (rdv.statut !== 'terminé') return;
  
  try {
    // Récupérer les données du patient
    const patientDoc = await getDoc(doc(db, 'patients', rdv.patientId));
    if (!patientDoc.exists()) return;
    
    const patientData = {
      id: rdv.patientId,
      ...patientDoc.data()
    };
    
    // Récupérer les détails de la structure
    const structureDoc = await getDoc(doc(db, 'structures', rdv.structureId));
    const structureName = structureDoc.exists() ? structureDoc.data().nom : 'Structure inconnue';
    
    // Préparer les données du rendez-vous pour la sauvegarde
    const rdvForBackup = {
      ...rdv,
      structureName,
      archivedAt: new Date()
    };
    
    // Sauvegarder le patient avec ce rendez-vous
    await savePatientBackup(patientData, [rdvForBackup]);
    
  } catch (error) {
    console.error("Erreur lors de l'archivage automatique du patient:", error);
  }
};




const DetailView = ({ 
  showDetails, 
  detailsType, 
  detailsItem, 
  setShowDetails, 
  isMobile, 
 
  // Rdv
  editingStatus, 
  newStatus, 
  setNewStatus, 
  // Functions
  calculateAge, 
  getStructureById, 
  getPatientById, 
  handleSaveArchiveNotes, 
  handleArchiveFileChange, 
  handleArchiveFileUpload, 
  handleDownloadArchiveFile, 
  handleDeleteArchiveFile, 
  handleDeleteArchive, 
  startEditStatus, 
  saveStatusChange, 
  cancelEditStatus, 
  // Fonction pour ouvrir la prévisualisation d'un fichier
  handleOpenFilePreview, 
  // Fonction pour fermer la prévisualisation
  handleCloseFilePreview 
}) => {
  if (!showDetails || !detailsItem) return null;
  
  // Style pour l'overlay modal
  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: isMobile ? 'start' : 'center',
    overflowY: 'auto',
    padding: isMobile ? '10px' : '30px'
  };
  
  // Style pour le contenu modal avec fond bleu
  const contentStyle = {
    backgroundColor: '#f0f8ff', // Fond bleu clair
    borderRadius: '12px',
    padding: '25px',
    maxWidth: isMobile ? '100%' : '800px',
    width: isMobile ? '95%' : '80%',
    maxHeight: isMobile ? '90vh' : '80vh',
    overflowY: 'auto',
    marginTop: isMobile ? '60px' : '0',
    boxShadow: '0 5px 25px rgba(0, 0, 0, 0.2)',
    border: '1px solid #e0f0ff'
  };
  
  // Style pour les cartes
  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '15px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)'
  };
  
  // Style pour les onglets
  const tabStyle = {
    border: 'none',
    backgroundColor: 'transparent',
    padding: '10px 15px',
    fontWeight: '500',
    color: '#4a6fa5',
    borderBottom: '2px solid transparent',
    transition: 'all 0.3s ease'
  };
  
  const activeTabStyle = {
    ...tabStyle,
    borderBottom: '2px solid #2c7be5',
    color: '#2c7be5'
  };
  
  // Gérer le clic sur un onglet d'archive
  const handleArchiveTabClick = (tabId) => {
    document.querySelectorAll('.tab-pane').forEach(el => el.classList.remove('active'));
    document.getElementById(tabId).classList.add('active');
    document.querySelectorAll('.archive-tab').forEach(el => {
      el.style.borderBottom = '2px solid transparent';
      el.style.color = '#4a6fa5';
    });
    document.getElementById(`${tabId}-tab`).style.borderBottom = '2px solid #2c7be5';
    document.getElementById(`${tabId}-tab`).style.color = '#2c7be5';
  };
  
  // Contenu selon le type
  let content;
  
  switch(detailsType) {
    case 'patient':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">{detailsItem.prenom} {detailsItem.nom}</h4>
          <div className="patient-details">
            <div className="row mb-2">
              <div className="col-md-6">
                <p><strong>Date de naissance:</strong> {new Date(detailsItem.dateNaissance).toLocaleDateString()}</p>
                <p><strong>Âge:</strong> {calculateAge(detailsItem.dateNaissance)} ans</p>
                <p><strong>Sexe:</strong> {detailsItem.sexe || 'Non spécifié'}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Téléphone:</strong> {detailsItem.telephone || 'Non spécifié'}</p>
                <p><strong>Email:</strong> {detailsItem.email || 'Non spécifié'}</p>
                <p><strong>Adresse:</strong> {detailsItem.adresse || 'Non spécifiée'}</p>
              </div>
            </div>
            
            {detailsItem.assurances && detailsItem.assurances.length > 0 && (
              <div className="mb-3 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
                <strong>Assurances:</strong> 
                <div className="mt-2">
                  {detailsItem.assurances.map((assurance, index) => (
                    <span key={index} className="badge bg-white text-primary me-2 mb-1 py-2 px-3" style={{borderRadius: '20px'}}>
                      {assurance}
                    </span>
                  ))}
                </div>
              </div>
            )}
            
            {detailsItem.antecedentsMedicaux && (
              <div className="mt-3 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
                <strong>Antécédents médicaux:</strong>
                <p className="text-muted mt-2 mb-0">{detailsItem.antecedentsMedicaux}</p>
              </div>
            )}
            {detailsItem.diagnostics && (
              <div className="mt-3 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
                <strong>Diagnostic:</strong>
                <p className="text-muted mt-2 mb-0">{detailsItem.diagnostics}</p>
              </div>
            )}
          </div>
        </div>
      );
      break;
      
    case 'rdv':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">Détails du rendez-vous</h4>
          <div className="row mb-3">
            <div className="col-md-6">
              <p><strong>Patient:</strong> {detailsItem.patientNom || 'Non spécifié'}</p>
              <p><strong>Structure ou Prestataire:</strong> {getStructureById(detailsItem.structureId).nom}</p>
              <p><strong>Motif:</strong> {detailsItem.motif || 'Non spécifié'}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Date:</strong> {new Date(detailsItem.date).toLocaleDateString()}</p>
              <p><strong>Heure:</strong> {detailsItem.heure}</p>
            </div>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Statut:</strong>
            {editingStatus ? (
              <div className="mt-2">
                <select 
                  className="form-select mb-2" 
                  value={newStatus}
                  onChange={(e) => setNewStatus(e.target.value)}
                  style={{borderRadius: '6px'}}
                >
                  <option value="confirmé">Confirmé</option>
                  <option value="terminé">Terminé</option>
                  <option value="annulé">Annulé</option>
                </select>
                <div className="d-flex gap-2 mt-2">
                  <button className="btn btn-sm btn-success" onClick={saveStatusChange} style={{borderRadius: '6px'}}>
                    <FontAwesomeIcon icon={faCheck} className="me-1" />
                    Enregistrer
                  </button>
                  <button className="btn btn-sm btn-secondary" onClick={cancelEditStatus} style={{borderRadius: '6px'}}>
                    <FontAwesomeIcon icon={faTimes} className="me-1" />
                    Annuler
                  </button>
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center mt-2">
                <span className={`badge status-badge-${detailsItem.statut} me-2 py-2 px-3`} style={{borderRadius: '20px'}}>
                  {detailsItem.statut.charAt(0).toUpperCase() + detailsItem.statut.slice(1)}
                </span>
                <button 
                  className="btn btn-sm btn-outline-primary" 
                  onClick={() => startEditStatus(detailsItem)}
                  style={{borderRadius: '6px'}}
                >
                  <FontAwesomeIcon icon={faEdit} className="me-1" />
                  Modifier
                </button>
              </div>
            )}
          </div>
          
          {detailsItem.patientId && (
            <div className="mt-4">
              <button 
                className="btn btn-outline-primary"
                onClick={() => {
                  const patient = getPatientById(detailsItem.patientId);
                  if (patient) {
                    setShowDetails(false);
                    // Utiliser un setTimeout pour s'assurer que la première modal est fermée
                    setTimeout(() => {
                      const event = new CustomEvent('viewPatient', { detail: patient });
                      document.dispatchEvent(event);
                    }, 100);
                  }
                }}
                style={{borderRadius: '6px'}}
              >
                <FontAwesomeIcon icon={faUser} className="me-1" />
                Voir le patient
              </button>
            </div>
          )}
          {detailsItem.patientId && (
            <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
              <strong>Diagnostic du patient:</strong>
              <p className="text-muted mt-2 mb-0">
                {getPatientById(detailsItem.patientId)?.diagnostics || 'Non spécifié'}
              </p>
            </div>
          )}
        </div>
      );
      break;
  
    case 'date-events':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">Rendez-vous du {detailsItem.date.toLocaleDateString()}</h4>
          {detailsItem.events.length > 0 ? (
            detailsItem.events.map(rdv => (
              <div key={rdv.id} className="mb-3 p-3" style={{backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)', borderLeft: `4px solid ${
                rdv.statut === 'confirmé' ? '#2c7be5' :
                rdv.statut === 'terminé' ? '#00d97e' :
                rdv.statut === 'annulé' ? '#e63757' : '#95aac9'
              }`}}>
                <div className="d-flex justify-content-between">
                  <h5 className="mb-1">{rdv.heure} - {rdv.patientNom || 'Patient non spécifié'}</h5>
                  <span className={`badge status-badge-${rdv.statut} py-2 px-3`} style={{borderRadius: '20px'}}>
                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                  </span>
                </div>
                <p className="mb-1"><strong>Structure ou Prestataire:</strong> {getStructureById(rdv.structureId).nom}</p>
                <p className="mb-1"><strong>Motif:</strong> {rdv.motif || 'Non spécifié'}</p>
                <div className="mt-2">
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      setShowDetails(false);
                      setTimeout(() => {
                        const event = new CustomEvent('viewRdv', { detail: rdv });
                        document.dispatchEvent(event);
                      }, 100);
                    }}
                    style={{borderRadius: '6px'}}
                  >
                    Détails
                  </button>
                  {rdv.patientId && (
                    <button 
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => {
                        const patient = getPatientById(rdv.patientId);
                        if (patient) {
                          setShowDetails(false);
                          setTimeout(() => {
                            const event = new CustomEvent('viewPatient', { detail: patient });
                            document.dispatchEvent(event);
                          }, 100);
                        }
                      }}
                      style={{borderRadius: '6px'}}
                    >
                      Voir patient
                    </button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center p-4 text-muted" style={{backgroundColor: 'white', borderRadius: '8px'}}>
              Aucun rendez-vous pour cette date
            </div>
          )}
        </div>
      );
      break;
      
    case 'backup':
      content = (
        <div style={cardStyle}>
          <h4 className="mb-4">Détails de la sauvegarde</h4>
          <div className="row mb-3">
            <div className="col-md-6">
              <p><strong>Patient:</strong> {detailsItem.patientData.prenom} {detailsItem.patientData.nom}</p>
              <p><strong>Date de naissance:</strong> {new Date(detailsItem.patientData.dateNaissance).toLocaleDateString()}</p>
              <p><strong>Sexe:</strong> {detailsItem.patientData.sexe || 'Non spécifié'}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Téléphone:</strong> {detailsItem.patientData.telephone || 'Non spécifié'}</p>
              <p><strong>Email:</strong> {detailsItem.patientData.email || 'Non spécifié'}</p>
              <p><strong>Adresse:</strong> {detailsItem.patientData.adresse || 'Non spécifiée'}</p>
            </div>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Assurances:</strong>
            <div className="mt-2">
              {detailsItem.patientData.assurances && detailsItem.patientData.assurances.map((assurance, index) => (
                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                  {assurance}
                </span>
              ))}
              {(!detailsItem.patientData.assurances || detailsItem.patientData.assurances.length === 0) && (
                <small className="text-muted">Aucune assurance spécifiée</small>
              )}
            </div>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Antécédents médicaux:</strong>
            <p className="text-muted mt-2 mb-0">{detailsItem.patientData.antecedentsMedicaux || 'Non spécifiés'}</p>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Diagnostic:</strong>
            <p className="text-muted mt-2 mb-0">{detailsItem.patientData.diagnostics || 'Non spécifié'}</p>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Rendez-vous:</strong>
            {detailsItem.rendezVous && detailsItem.rendezVous.length > 0 ? (
              <div className="mt-2">
                {detailsItem.rendezVous.map((rdv, index) => (
                  <div key={index} className="mb-2">
                    <p><strong>Date:</strong> {new Date(rdv.date).toLocaleDateString()}</p>
                    <p><strong>Heure:</strong> {rdv.heure}</p>
                    <p><strong>Motif:</strong> {rdv.motif || 'Non spécifié'}</p>
                    <p><strong>Statut:</strong> {rdv.statut}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted">Aucun rendez-vous enregistré</p>
            )}
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Notes:</strong>
            <p className="text-muted mt-2 mb-0">{detailsItem.notes || 'Aucun note'}</p>
          </div>
          
          <div className="mt-4 p-3" style={{backgroundColor: '#e6f2ff', borderRadius: '8px'}}>
            <strong>Fichiers:</strong>
            <div className="mt-2">
              {detailsItem.files && detailsItem.files.length > 0 ? (
                <div className="list-group">
                  {detailsItem.files.map((file, index) => (
                    <div key={index} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                      <div className="text-truncate" style={{ maxWidth: '60%' }}>
                        <FontAwesomeIcon 
                          icon={
                            file.type.includes('pdf') ? faFilePdf :
                            file.type.includes('word') ? faFileWord :
                            file.type.includes('excel') ? faFileExcel :
                            file.type.includes('image') ? faFile :
                            faFile
                          } 
                          className="me-2 text-primary"
                        />
                        {file.name}
                      </div>
                      <div>
                        <button 
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => handleDownloadBackupFile(file)}
                        >
                          <FontAwesomeIcon icon={faFileDownload} />
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDeleteBackupFile(file.id)}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-muted">Aucun fichier associé à ce patient</p>
              )}
            </div>
          </div>
        </div>
      );
      break;
      
    default:
      content = <p>Détails non disponibles</p>;
  }
  
  return (
    <div style={modalStyle} onClick={() => setShowDetails(false)}>
      <div 
        style={contentStyle} 
        onClick={e => e.stopPropagation()}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0" style={{color: '#2c7be5'}}>{
            detailsType === 'patient' ? 'Détails du patient' :
            detailsType === 'rdv' ? 'Détails du rendez-vous' :
            detailsType === 'backup' ? 'Détails de la sauvegarde' :
            'Détails'
          }</h3>
          <button 
            className="btn-close" 
            onClick={() => setShowDetails(false)}
            aria-label="Fermer"
          ></button>
        </div>
        <div className="detail-content">
          {content}
        </div>
        <div className="mt-4 text-end">
          <button 
            className="btn btn-secondary" 
            onClick={() => setShowDetails(false)}
            style={{borderRadius: '6px'}}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};


const [showSidebar, setShowSidebar] = useState(false);
 
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setShowSidebar(false);
    setMobileDetailView(null);
  };


  const filteredPatients = patients.filter(patient => {
    // Ajoutez votre logique de filtrage ici
    // Par exemple, filtrer par nom si vous avez un état searchTerm
    if (searchTerm) {
      return patient.nom.toLowerCase().includes(searchTerm.toLowerCase()) || 
             patient.prenom.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return true; // Retourne tous les patients si aucun filtre n'est appliqué
  });


  const handleSaveRdvNotes = async (rdvId, notes) => {
    try {
      // Mettre à jour dans Firestore
      await updateDoc(doc(db, 'rendezvous', rdvId), {
        notes: notes,
        updatedAt: new Date()
      });
      
      // Mettre à jour l'UI localement
      setRendezvous(prev => prev.map(rdv => 
        rdv.id === rdvId ? {...rdv, notes: notes} : rdv
      ));
      
      setMessage('Notes enregistrées avec succès');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des notes:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleCreateBackup = async (patient) => {
    try {
      // Récupérer les rendez-vous associés à ce patient
      const patientRdvs = rendezvous.filter(rdv => rdv.patientId === patient.id);
      
      // Sauvegarder le patient avec ses rendez-vous
      await savePatientBackup(patient, patientRdvs);
      
      setMessage(`Sauvegarde de ${patient.prenom} ${patient.nom} créée avec succès`);
      setTimeout(() => setMessage(''), 3000);
      
      // Fermer la vue détaillée
      setShowDetails(false);
      
      // Optionnel: changer d'onglet pour les sauvegardes
      setActiveTab('sauvegardes');
    } catch (error) {
      console.error("Erreur lors de la création de la sauvegarde:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleSavePatientNotes = async (patientId, notesMedicales) => {
    try {
      // Mettre à jour dans Firestore
      await updateDoc(doc(db, 'patients', patientId), {
        notesMedicales: notesMedicales,
        updatedAt: new Date()
      });
      
      // Mettre à jour l'UI localement
      setPatients(prev => prev.map(patient => 
        patient.id === patientId ? {...patient, notesMedicales: notesMedicales} : patient
      ));
      
      setMessage('Notes médicales enregistrées avec succès');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des notes médicales:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };

  

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  // Interface mobile
  if (isMobile) {
    // Interface mobile
    return (
      <div className="dashboard-container mobile">
        {/* En-tête mobile avec menu hamburger */}
        <div className="mobile-header">
          <button className="menu-toggle" onClick={toggleMobileMenu}>
            <FontAwesomeIcon icon={faBars} />
          </button>
          <h3 className="mobile-title">
            {activeTab === 'info' && 'Mon Profil'}
            {activeTab === 'qrcodes' && 'Codes QR'}
            {activeTab === 'rendezvous' && 'Rendez-vous'}
            {activeTab === 'patients' && 'Patients'}
            {activeTab === 'messagerie' && 'Messagerie'}
            {activeTab === 'affiliations' && 'Affiliations'}
            {activeTab === 'sauvegardes' && 'Sauvegardes'}
            {activeTab === 'password' && 'Mot de passe'}
          </h3>
          <div className="mobile-avatar">
            {medecinData?.prenom?.charAt(0)}{medecinData?.nom?.charAt(0)}
          </div>
        </div>
    
        {/* Menu latéral mobile (s'affiche uniquement quand ouvert) */}
        <div className={`mobile-sidebar ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-sidebar-header">
            <h3>{medecinData?.titre || "Dr"} {medecinData?.nom}</h3>
            <button className="close-menu" onClick={toggleMobileMenu}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          
          <div className="mobile-sidebar-menu">
            <ul>
              <li className={activeTab === 'info' ? 'active' : ''} onClick={() => {setActiveTab('info'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faUserMd} />
                <span>Mon Profil</span>
              </li>
              <li className={activeTab === 'qrcodes' ? 'active' : ''} onClick={() => {setActiveTab('qrcodes'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faQrcode} />
                <span>Codes QR</span>
              </li>
              <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => {setActiveTab('rendezvous'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faCalendarAlt} />
                <span>Rendez-vous</span>
                <span className="badge bg-info">{rendezvous.length}</span>
              </li>
              <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => {setActiveTab('patients'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faUser} />
                <span>Patients</span>
                <span className="badge bg-info">{patients.length}</span>
              </li>
              <li className={activeTab === 'messagerie' ? 'active' : ''} onClick={() => {setActiveTab('messagerie'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faComments} />
                <span>Messagerie</span>
                {unreadMessagesCount > 0 && <span className="badge bg-danger">{unreadMessagesCount}</span>}
              </li>
              <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => {setActiveTab('affiliations'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faClinicMedical} />
                <span>Affiliations</span>
                {pendingAffiliations.length > 0 && <span className="badge bg-danger">{pendingAffiliations.length}</span>}
              </li>
              <li className={activeTab === 'sauvegardes' ? 'active' : ''} onClick={() => {setActiveTab('sauvegardes'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faArchive} />
                <span>Sauvegardes</span>
                <span className="badge bg-info">{backups.length}</span>
              </li>
              <li className={activeTab === 'password' ? 'active' : ''} onClick={() => {setActiveTab('password'); toggleMobileMenu();}}>
                <FontAwesomeIcon icon={faKey} />
                <span>Mot de passe</span>
              </li>
              <li onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Déconnexion</span>
              </li>
            </ul>
          </div>
        </div>
    
        {/* Contenu principal */}
        <div className="mobile-content">
          {/* Affichage des messages de notification */}
          {message && (
            <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
              {message}
              <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
            </div>
          )}
    
          {/* Contenu des différents onglets */}
          {/* Onglet Mon Profil */}
          {activeTab === 'info' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-center mb-4">
                  <div className="avatar-circle bg-primary text-white mx-auto">
                    {medecinData?.prenom?.charAt(0)}{medecinData?.nom?.charAt(0)}
                  </div>
                  <h4 className="mt-3">{medecinData?.titre || "Dr"} {medecinData?.nom}</h4>
<span className="badge bg-info me-2">{medecinData?.specialite}</span>
{medecinData?.consultationDomicile && (
  <span className="badge bg-success">
    <FontAwesomeIcon icon={faHome} className="me-1" />
    Consultations à domicile
  </span>
)}

                </div>
                
                <div className="mb-3">
                  <label className="form-label">Prénom et Nom</label>
                  <input
                    name="nom"
                    value={form.nom || ''}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Nom"
                  />
                </div>
                
                
                
                <div className="mb-3">
                  <label className="form-label">Spécialité</label>
                  <input
                    name="specialite"
                    value={form.specialite || ''}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Spécialité"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Téléphone</label>
                  <input
                    name="telephone"
                    value={form.telephone || ''}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Téléphone"
                  />
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    name="email"
                    value={form.email || ''}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Email"
                    disabled
                  />
                </div>
                <div className="mb-3">
  <label className="form-label">Options de consultation</label>
  <div className="form-check form-switch">
    <input
      className="form-check-input"
      type="checkbox"
      id="mobile-consultationDomicile"
      checked={form.consultationDomicile || false}
      onChange={(e) => {
        setForm({
          ...form,
          consultationDomicile: e.target.checked
        });
      }}
    />
    <label className="form-check-label" htmlFor="mobile-consultationDomicile">
      <FontAwesomeIcon icon={faHome} className="me-2 text-success" />
      Consultations à domicile
    </label>
  </div>
</div>

                <div className="mb-3">
  <label className="form-label">Disponibilités</label>
  <div className="accordion" id="disponibilitesAccordion">
    {form.disponibilites && Object.entries(form.disponibilites).map(([jour, dispo], index) => (
      <div className="accordion-item" key={jour}>
        <h2 className="accordion-header" id={`heading-${jour}`}>
          <button 
            className="accordion-button collapsed" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target={`#collapse-${jour}`}
          >
            {jour.charAt(0).toUpperCase() + jour.slice(1)} - {dispo.actif ? 'Disponible' : 'Non disponible'}
          </button>
        </h2>
        <div 
          id={`collapse-${jour}`} 
          className="accordion-collapse collapse" 
          aria-labelledby={`heading-${jour}`} 
          data-bs-parent="#disponibilitesAccordion"
        >
          <div className="accordion-body">
            <div className="form-check form-switch mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id={`disponible-${jour}`}
                checked={dispo.actif || false}
                onChange={() => handleDisponibiliteChange(jour, "actif")}
              />
              <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                {dispo.actif ? 'Disponible' : 'Non disponible'}
              </label>
            </div>
            
            {dispo.actif && dispo.creneaux.map((creneau, creneauIndex) => (
              <div key={creneauIndex} className="border-bottom pb-2 mb-2">
                <h6 className="mb-2">Créneau {creneauIndex + 1}</h6>
                <div className="row mb-2">
                  <div className="col-6">
                    <label className="form-label">Début</label>
                    <input
                      type="time"
                      className="form-control"
                      value={creneau.debut || '08:00'}
                      onChange={(e) => handleDisponibiliteChange(jour, "debut", e.target.value, creneauIndex)}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Fin</label>
                    <input
                      type="time"
                      className="form-control"
                      value={creneau.fin || '18:00'}
                      onChange={(e) => handleDisponibiliteChange(jour, "fin", e.target.value, creneauIndex)}
                    />
                  </div>
                </div>
                
                <div className="row mb-2">
                  <div className="col-12">
                    <label className="form-label">Structure ou Prestataire</label>
                    <select
                      className="form-select"
                      value={creneau.structureId || ''}
                      onChange={(e) => handleDisponibiliteChange(jour, "structureId", e.target.value, creneauIndex)}
                    >
                      <option value="">Sélectionner une structure ou un prestataire</option>
                      {getAvailableStructures(jour, dispo).map(structure => (
                        <option key={structure.id} value={structure.id}>
                          {structure.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                {dispo.creneaux.length > 1 && (
                  <div className="d-grid mt-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => removeCreneau(jour, creneauIndex)}
                    >
                      <FontAwesomeIcon icon={faTimes} className="me-1" />
                      Supprimer ce créneau
                    </button>
                  </div>
                )}
              </div>
            ))}
            
            <div className="d-grid mt-3">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => addCreneau(jour)}
                disabled={!dispo.actif}
              >
                <FontAwesomeIcon icon={faPlus} className="me-1" />
                Ajouter un créneau
              </button>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

                
                <div className="d-grid mt-4">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    Mettre à jour
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Onglet Codes QR Mobile */}
          {activeTab === 'qrcodes' && (
            <div className="mobile-qr-section">
              <QRCodeManager 
                medecinId={auth.currentUser?.uid} 
                affiliatedStructures={affiliatedStructures}
                medecinData={medecinData}
              />
            </div>
          )}
    
          {/* Onglet Rendez-vous */}
          {activeTab === 'rendezvous' && (
            <div>
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="btn-group w-100 mb-2">
                      <button 
                        className={`btn ${viewMode === 'calendar' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('calendar')}
                      >
                        <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                        Calendrier
                      </button>
                      <button 
                        className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('list')}
                      >
                        <FontAwesomeIcon icon={faList} className="me-1" />
                        Liste
                      </button>
                    </div>
                  </div>
                  
                  <div className="mb-2">
                    <div className="input-group mb-2">
                      <span className="input-group-text">Date</span>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={filtreDate}
                        onChange={(e) => setFiltreDate(e.target.value)}
                      />
                    </div>
                    
                    <div className="input-group mb-2">
                      <span className="input-group-text">Statut</span>
                      <select 
                        className="form-select" 
                        value={filtreStatut}
                        onChange={(e) => setFiltreStatut(e.target.value)}
                      >
                        <option value="tous">Tous statuts</option>
                        <option value="confirmé">Confirmé</option>
                        <option value="terminé">Terminé</option>
                        <option value="annulé">Annulé</option>
                      </select>
                    </div>
                    
                    <div className="input-group">
                      <span className="input-group-text">Structure</span>
                      <select 
                        className="form-select"
                        value={filtreStructure}
                        onChange={(e) => setFiltreStructure(e.target.value)}
                      >
                        <option value="">Toutes structures</option>
                        {affiliatedStructures.map(structure => (
                          <option key={structure.id} value={structure.id}>
                            {structure.nom}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                
                <div className="card-body">
                  {viewMode === 'calendar' ? (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <button className="btn btn-sm btn-outline-secondary" onClick={handlePrevMonth}>
                          <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <h5 className="mb-0">
                          {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                        </h5>
                        <button className="btn btn-sm btn-outline-secondary" onClick={handleNextMonth}>
                          <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                      </div>
                      
                      <div className="mobile-calendar">
                        <div className="mobile-calendar-header">
                          {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
                            <div key={index} className="mobile-calendar-cell header">
                              {day}
                            </div>
                          ))}
                        </div>
                        <div className="mobile-calendar-body">
                          {getMonthData().map((day, index) => (
                            <div 
                              key={index} 
                              className={`mobile-calendar-cell ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                              onClick={() => handleMobileDateClick(day)}
                            >
                              <div className="date-number">{day.date.getDate()}</div>
                              {day.hasEvents && (
                                <div className="event-indicator">
                                  <span className="event-dot"></span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="list-group">
                      {filteredRendezvous.length > 0 ? (
                        filteredRendezvous.map(rdv => (
                          <div key={rdv.id} className={`list-group-item list-group-item-action status-row-${rdv.statut}`}>
                            <div className="d-flex w-100 justify-content-between">
                              <h6 className="mb-1">{new Date(rdv.date).toLocaleDateString()} - {rdv.heure}</h6>
                              <span className={`badge status-badge-${rdv.statut}`}>
                                {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                              </span>
                            </div>
                            <p className="mb-1">
                              <strong>Patient:</strong> {rdv.patientNom || 'Non spécifié'}
                              {rdv.patientId && (
                                <button 
                                  className="btn btn-sm btn-link p-0 ms-2"
                                  onClick={() => handleViewPatient(rdv.patientId)}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </button>
                              )}
                            </p>
                            <p className="mb-1"><strong>Structure:</strong> {getStructureById(rdv.structureId).nom}</p>
                            <p className="mb-1"><strong>Motif:</strong> {rdv.motif || 'Non spécifié'}</p>
                            <div className="mt-2">
                              <button 
                                className="btn btn-sm btn-outline-primary w-100"
                                onClick={() => {
                                  setDetailsType('rdv');
                                  setDetailsItem(rdv);
                                  setShowDetails(true);
                                  setNewStatus(rdv.statut);
                                }}
                              >
                                <FontAwesomeIcon icon={faEye} className="me-1" />
                                Voir détails
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">Aucun rendez-vous trouvé</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
    
          {/* Onglet Patients */}
          {activeTab === 'patients' && (
            <div>
              <ul className="nav nav-pills nav-justified mb-3">
                <li className="nav-item">
                  <button 
                    className={`nav-link ${patientSubTab === 'list' ? 'active' : ''}`}
                    onClick={() => setPatientSubTab('list')}
                  >
                    Liste
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${patientSubTab === 'manage' ? 'active' : ''}`}
                    onClick={() => setPatientSubTab('manage')}
                  >
                    Gestion
                  </button>
                </li>
              </ul>
              
              {patientSubTab === 'list' && (
                <div className="card shadow-sm">
                  <div className="card-header bg-light">
                    <div className="input-group">
                      <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Rechercher un patient..." 
                        value={searchPatient}
                        onChange={(e) => setSearchPatient(e.target.value)}
                      />
                      <button className="btn btn-outline-primary">
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="list-group list-group-flush">
                      {patients.length > 0 ? (
                        patients
                          .filter(patient => {
                            const fullName = `${patient.prenom} ${patient.nom}`.toLowerCase();
                            return fullName.includes(searchPatient.toLowerCase());
                          })
                          .map((patient) => {
                            // Trouver les rendez-vous associés à ce patient
                            const patientRdvs = rendezvous.filter(rdv => rdv.patientId === patient.id);
                            // Trouver les structures uniques associées aux rendez-vous
                            const structureIds = [...new Set(patientRdvs.map(rdv => rdv.structureId))];
                            const patientStructures = structureIds.map(id => getStructureById(id));
                            
                            return (
                              <div className="list-group-item" key={patient.id}>
                                <div className="d-flex justify-content-between align-items-start">
                                  <h6 className="mb-1">{patient.prenom} {patient.nom}</h6>
                                  <span className="badge bg-secondary">
                                    {calculateAge(patient.dateNaissance)} ans
                                  </span>
                                </div>
                                <p className="mb-1 small">
                                  <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                                  {patient.telephone || 'Non spécifié'}
                                </p>
                                <p className="mb-1 small">
                                  <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                                  {patient.email || 'Non spécifié'}
                                </p>
                                {patientStructures.length > 0 && (
                                  <div className="mb-2">
                                    <small className="text-muted">Structures:</small>
                                    <div className="d-flex flex-wrap mt-1">
                                      {patientStructures.map((structure, index) => (
                                        <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                          {structure.nom}
                                        </span>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                <div className="d-flex justify-content-between mt-2">
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => handleManualArchivePatient(patient)}
                                  >
                                    <FontAwesomeIcon icon={faArchive} className="me-1" />
                                    Archiver
                                  </button>
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => handleViewDetails('patient', getPatientById(patient.id))}
                                  >
                                    <FontAwesomeIcon icon={faEye} className="me-1" />
                                    Détails
                                  </button>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div className="text-center py-4">
                          <p className="text-muted">Aucun patient associé à vos rendez-vous</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              
              {patientSubTab === 'manage' && (
                <div className="card shadow-sm">
                  <div className="card-body">
                    <MedecinPatientManager 
                      medecinId={auth.currentUser?.uid}
                      affiliatedStructures={affiliatedStructures}
                      patients={patients}
                      onPatientAdd={(newPatient) => {
                        setPatients(prevPatients => [...prevPatients, newPatient]);
                      }}
                      onPatientUpdate={(updatedPatient) => {
                        setPatients(prevPatients => 
                          prevPatients.map(p => p.id === updatedPatient.id ? updatedPatient : p)
                        );
                      }}
                      onPatientArchive={(patientId) => {
                        setPatients(prevPatients => 
                          prevPatients.map(p => p.id === patientId ? {...p, archived: true} : p)
                        );
                      }}
                      isMobile={true}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
    
          {/* Onglet Affiliations */}
          {activeTab === 'affiliations' && (
            <div>
              <ul className="nav nav-pills nav-justified mb-3">
                <li className="nav-item">
                  <button 
                    className={`nav-link ${affiliationSubTab === 'search' ? 'active' : ''}`}
                    onClick={() => setAffiliationSubTab('search')}
                  >
                    Recherche
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${affiliationSubTab === 'requests' ? 'active' : ''}`}
                    onClick={() => setAffiliationSubTab('requests')}
                  >
                    Demandes
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${affiliationSubTab === 'affiliated' ? 'active' : ''}`}
                    onClick={() => setAffiliationSubTab('affiliated')}
                  >
                    Affiliées
                  </button>
                </li>
              </ul>
              
              {/* Recherche et demande d'affiliation à de nouvelles structures */}
              {affiliationSubTab === 'search' && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Rechercher</h5>
                    <div>
                      <button 
                        className="btn btn-sm btn-outline-secondary"
                        onClick={refreshAffiliations}
                        disabled={loading}
                      >
                        <FontAwesomeIcon icon={faRedo} className={loading ? "fa-spin" : ""} />
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <div className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher une structure..."
                          value={searchStructure}
                          onChange={(e) => setSearchStructure(e.target.value)}
                        />
                        <button className="btn btn-outline-primary" type="button">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                      
                      <select 
                        className="form-select mt-2"
                        value={filtreSpecialite}
                        onChange={(e) => setFiltreSpecialite(e.target.value)}
                      >
                        <option value="">Toutes spécialités</option>
                        {specialites.map((specialite, index) => (
                          <option key={index} value={specialite}>{specialite}</option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="list-group">
                      {filteredStructures.length > 0 ? (
                        filteredStructures.map(structure => {
                          // Vérifier si déjà affilié ou demande en cours
                          const isAffiliated = affiliatedStructures.some(s => s.id === structure.id);
                          const hasPendingRequest = sentAffiliationRequests.some(req => 
                            req.structureId === structure.id && req.status === "pending"
                          );
                          const hasRejectedRequest = sentAffiliationRequests.some(req => 
                            req.structureId === structure.id && req.status === "rejected"
                          );
                          
                          return (
                            <div key={structure.id} className="list-group-item">
                              <h6 className="mb-1">{structure.nom}</h6>
                              <div className="mb-1">
                                {Array.isArray(structure.specialites) ? (
                                  structure.specialites.map((specialite, index) => (
                                    <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                      {specialite}
                                    </span>
                                  ))
                                ) : (
                                  <span className="text-muted">Aucune spécialité</span>
                                )}
                              </div>
                              <p className="mb-2 small">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-secondary" />
                                {structure.adresse || 'Non spécifiée'}
                              </p>
                              <div className="d-grid">
                                {isAffiliated ? (
                                  <button 
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDesaffiliation(structure.id)}
                                  >
                                    <FontAwesomeIcon icon={faUnlink} className="me-1" />
                                    Se désaffilier
                                  </button>
                                ) : hasPendingRequest ? (
                                  <span className="badge bg-warning text-dark p-2 w-100">Demande en attente</span>
                                ) : hasRejectedRequest ? (
                                  <span className="badge bg-danger p-2 w-100">Demande rejetée</span>
                                ) : (
                                  <button 
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => handleRequestAffiliation(structure.id)}
                                  >
                                    <FontAwesomeIcon icon={faLink} className="me-1" />
                                    Demander affiliation
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center py-3">
                          <p className="text-muted">Aucune structure trouvée</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              
              {/* Demandes d'affiliation en cours */}
              {affiliationSubTab === 'requests' && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header">
                    <h5>Demandes en cours</h5>
                  </div>
                  <div className="card-body">
                    {sentAffiliationRequests.filter(req => req.status === "pending").length > 0 ? (
                      <div className="list-group">
                        {sentAffiliationRequests.filter(req => req.status === "pending").map(request => (
                          <div key={request.id} className="list-group-item">
                            <div className="d-flex justify-content-between align-items-center">
                              <h6 className="mb-1">{request.structureName}</h6>
                              <small className="text-muted">
                                {new Date(request.createdAt.toDate()).toLocaleDateString()}
                              </small>
                            </div>
                            <div className="d-grid mt-2">
                              <button 
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleCancelRequest(request.id)}
                              >
                                <FontAwesomeIcon icon={faTimes} className="me-1" />
                                Annuler la demande
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="alert alert-info">
                        Aucune demande d'affiliation en cours
                      </div>
                    )}
                  </div>
                </div>
              )}
    
              
                          {/* Structures affiliées */}
              {affiliationSubTab === 'affiliated' && (
                <div className="card shadow-sm">
                  <div className="card-header">
                    <h6>Mes structures et/ou Prestataires  affiliées</h6>
                  </div>
                  <div className="card-body">
                    {affiliatedStructures.length > 0 ? (
                      <div className="list-group">
                        {affiliatedStructures.map(structure => (
                          <div className="list-group-item" key={structure.id}>
                            <h6 className="mb-1">{structure.nom}</h6>
                            <p className="mb-1 small">
                              <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                              {structure.telephone || 'Non spécifié'}
                            </p>
                            <p className="mb-1 small">
                              <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                              {structure.email || 'Non spécifié'}
                            </p>
                            <p className="mb-2 small">
                              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-secondary" />
                              {structure.adresse || 'Adresse non spécifiée'}
                            </p>
                            <div className="d-grid">
                              <button 
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDesaffiliation(structure.id)}
                              >
                                <FontAwesomeIcon icon={faUnlink} className="me-1" />
                                Se désaffilier
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="alert alert-info">
                        Aucune structure affiliée
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
    
          {/* Onglet Sauvegardes */}
          {activeTab === 'sauvegardes' && (
            <div>
              {!selectedBackup ? (
                <div className="card shadow-sm mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Patients sauvegardés</h5>
                    <div className="input-group input-group-sm" style={{ width: '60%' }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Rechercher..."
                        value={backupSearchTerm}
                        onChange={(e) => setBackupSearchTerm(e.target.value)}
                      />
                      <button className="btn btn-outline-secondary" type="button">
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </div>
                  <div className="card-body p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <div className="list-group list-group-flush">
                      {backups
                        .filter(backup => {
                          const patientName = `${backup.patientData.prenom} ${backup.patientData.nom}`.toLowerCase();
                          return patientName.includes(backupSearchTerm.toLowerCase());
                        })
                        .map(backup => (
                          <button
                            key={backup.id}
                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            onClick={() => {
                              setSelectedBackup(backup);
                              setBackupNotes(backup.notes || '');
                              setBackupFiles(backup.files || []);
                            }}
                          >
                            <div>
                              <div className="fw-bold">{backup.patientData.prenom} {backup.patientData.nom}</div>
                              <small className="text-muted">
                                Mis à jour le {new Date(backup.updatedAt).toLocaleDateString()}
                              </small>
                            </div>
                            <span className="badge bg-info rounded-pill">
                              {(backup.files || []).length} fichier(s)
                            </span>
                          </button>
                        ))}
                      {backups.length === 0 && (
                        <div className="text-center py-4 text-muted">
                          Aucune sauvegarde trouvée
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card shadow-sm">
                  <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      {selectedBackup.patientData.prenom} {selectedBackup.patientData.nom}
                      <span className="badge bg-light text-dark ms-2">
                        {calculateAge(selectedBackup.patientData.dateNaissance)} ans
                      </span>
                    </h5>
                    <button 
                      className="btn btn-sm btn-light"
                      onClick={() => setSelectedBackup(null)}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                  </div>
                  <div className="card-body">
                    <ul className="nav nav-pills nav-justified mb-3" id="backupTabs" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button 
                          className={`nav-link ${backupTab === 'info' ? 'active' : ''}`}
                          onClick={() => setBackupTab('info')}
                        >
                          Infos
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button 
                          className={`nav-link ${backupTab === 'rdv' ? 'active' : ''}`}
                          onClick={() => setBackupTab('rdv')}
                        >
                          Rendez-vous
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button 
                          className={`nav-link ${backupTab === 'notes' ? 'active' : ''}`}
                          onClick={() => setBackupTab('notes')}
                        >
                          Notes
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button 
                          className={`nav-link ${backupTab === 'files' ? 'active' : ''}`}
                          onClick={() => setBackupTab('files')}
                        >
                          Fichiers
                        </button>
                      </li>
                    </ul>
                    
                    <div className="tab-content pt-2">
                      {/* Onglet Informations */}
                      {backupTab === 'info' && (
                        <div>
                          <div className="mb-3">
                            <label className="form-label fw-bold">Date de naissance</label>
                            <p>{new Date(selectedBackup.patientData.dateNaissance).toLocaleDateString()}</p>
                          </div>
                          
                          <div className="mb-3">
                            <label className="form-label fw-bold">Sexe</label>
                            <p>{selectedBackup.patientData.sexe || 'Non spécifié'}</p>
                          </div>
                          
                          <div className="mb-3">
                            <label className="form-label fw-bold">Téléphone</label>
                            <p>{selectedBackup.patientData.telephone || 'Non spécifié'}</p>
                          </div>
                          
                          <div className="mb-3">
                            <label className="form-label fw-bold">Email</label>
                            <p>{selectedBackup.patientData.email || 'Non spécifié'}</p>
                          </div>
                          
                          <div className="mb-3">
                            <label className="form-label fw-bold">Adresse</label>
                            <p>{selectedBackup.patientData.adresse || 'Non spécifiée'}</p>
                          </div>
                          
                          <div className="mb-3">
                            <label className="form-label fw-bold">Assurances</label>
                            <div>
                              {selectedBackup.patientData.assurances && selectedBackup.patientData.assurances.map((assurance, index) => (
                                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                  {assurance}
                                </span>
                              ))}
                              {(!selectedBackup.patientData.assurances || selectedBackup.patientData.assurances.length === 0) && (
                                <p className="text-muted">Aucune assurance spécifiée</p>
                              )}
                            </div>
                          </div>
                          
                          <div className="mb-3">
                            <label className="form-label fw-bold">Antécédents médicaux</label>
                            <p className="text-muted">
                              {selectedBackup.patientData.antecedentsMedicaux || 'Non spécifiés'}
                            </p>
                          </div>
    
                          <div className="mb-3">
                            <label className="form-label fw-bold">Diagnostic</label>
                            <p className="text-muted">
                              {selectedBackup.patientData.diagnostics || 'Non spécifié'}
                            </p>
                          </div>
                        </div>
                      )}
                      
                      {/* Onglet Rendez-vous */}
                      {backupTab === 'rdv' && (
                        <div>
                          {selectedBackup.rendezVous && selectedBackup.rendezVous.length > 0 ? (
                            <div className="list-group">
                              {selectedBackup.rendezVous.map((rdv, index) => (
                                <div key={index} className={`list-group-item status-row-${rdv.statut}`}>
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <div>
                                      <strong>{new Date(rdv.date).toLocaleDateString()}</strong> - {rdv.heure}
                                    </div>
                                    <span className={`badge status-badge-${rdv.statut}`}>
                                      {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                                    </span>
                                  </div>
                                  <p className="mb-1"><strong>Structure:</strong> {rdv.structureName || getStructureById(rdv.structureId).nom}</p>
                                  <p className="mb-0"><strong>Motif:</strong> {rdv.motif || 'Non spécifié'}</p>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="alert alert-info">
                              Aucun rendez-vous enregistré pour ce patient
                            </div>
                          )}
                        </div>
                      )}
                      
                      {/* Onglet Notes */}
                      {backupTab === 'notes' && (
                        <div>
                          <div className="mb-3">
                            <label className="form-label">Notes de suivi</label>
                            <textarea 
                              className="form-control" 
                              rows="8"
                              value={backupNotes}
                              onChange={(e) => setBackupNotes(e.target.value)}
                              placeholder="Ajoutez vos notes concernant ce patient ici..."
                            ></textarea>
                          </div>
                          <div className="d-grid">
                            <button 
                              className="btn btn-primary"
                              onClick={handleSaveBackupNotes}
                              disabled={loading}
                            >
                              {loading ? (
                                <><FontAwesomeIcon icon={faCircleNotch} spin className="me-1" /> Enregistrement...</>
                              ) : (
                                <><FontAwesomeIcon icon={faSave} className="me-1" /> Enregistrer les notes</>
                              )}
                            </button>
                          </div>
                        </div>
                      )}
                      
                      {/* Onglet Fichiers */}
                      {backupTab === 'files' && (
                        <div>
                          <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <label className="form-label mb-0">Fichiers associés</label>
                              <div>
                                <input
                                  type="file"
                                  id="backupFileInput"
                                  className="d-none"
                                  onChange={handleBackupFileChange}
                                />
                                <label htmlFor="backupFileInput" className="btn btn-sm btn-outline-primary mb-0">
                                  <FontAwesomeIcon icon={faFileUpload} className="me-1" />
                                  Ajouter
                                </label>
                              </div>
                            </div>
                            
                            {backupFileToUpload && (
                              <div className="alert alert-info d-flex justify-content-between align-items-center">
                                <div className="text-truncate">
                                  <FontAwesomeIcon icon={faFile} className="me-2" />
                                  {backupFileToUpload.name}
                                </div>
                                <div>
                                  <button 
                                    className="btn btn-sm btn-primary me-1"
                                    onClick={handleBackupFileUpload}
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <FontAwesomeIcon icon={faCircleNotch} spin />
                                    ) : (
                                      <FontAwesomeIcon icon={faFileUpload} />
                                    )}
                                  </button>
                                  <button 
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => setBackupFileToUpload(null)}
                                    disabled={loading}
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </button>
                                </div>
                              </div>
                            )}
                            
                            <div className="list-group mt-3">
                              {backupFiles && backupFiles.length > 0 ? (
                                backupFiles.map((file, index) => (
                                  <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div className="text-truncate">
                                      <FontAwesomeIcon 
                                        icon={
                                          file.type.includes('pdf') ? faFilePdf :
                                          file.type.includes('word') ? faFileWord :
                                          file.type.includes('excel') ? faFileExcel :
                                          file.type.includes('image') ? faFile :
                                          faFile
                                        } 
                                        className="me-2 text-primary"
                                      />
                                      {file.name}
                                    </div>
                                    <div>
                                      <button 
                                        className="btn btn-sm btn-outline-primary me-1"
                                        onClick={() => handleDownloadBackupFile(file)}
                                      >
                                        <FontAwesomeIcon icon={faFileDownload} />
                                      </button>
                                      <button 
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDeleteBackupFile(file.id)}
                                        disabled={loading}
                                      >
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                      </button>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="text-center py-3 text-muted">
                                  Aucun fichier associé à ce patient
                                </div>
                              )}
                            </div>
                          </div>
                          
                          <div className="d-grid mt-4">
                            <button 
                              className="btn btn-danger"
                              onClick={() => handleDeleteBackup(selectedBackup.id)}
                              disabled={loading}
                            >
                              <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
                              Supprimer cette sauvegarde
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
    
          {/* Onglet Messagerie */}
          {activeTab === 'messagerie' && (
            <div className="card shadow-sm">
              <div className="card-body p-0">
                {!selectedConversation ? (
                  <div className="mobile-messaging">
                    <div className="mobile-tabs">
                      <button 
                        className={`mobile-tab ${messagingTab === 'conversations' ? 'active' : ''}`}
                        onClick={() => setMessagingTab('conversations')}
                      >
                        Conversations
                      </button>
                      <button 
                        className={`mobile-tab ${messagingTab === 'patients' ? 'active' : ''}`}
                        onClick={() => setMessagingTab('patients')}
                      >
                        Patients
                      </button>
                    </div>
                    
                    <div className="p-2">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher..."
                          value={searchPatientTerm}
                          onChange={(e) => setSearchPatientTerm(e.target.value)}
                        />
                        <button className="btn btn-outline-primary" type="button">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </div>
                    
                    {messagingTab === 'conversations' && (
                      <div className="list-group list-group-flush">
                        {conversations.length > 0 ? (
                          conversations.map(conversation => (
                            <button
                              key={conversation.id}
                              className="list-group-item list-group-item-action d-flex align-items-center"
                              onClick={() => setSelectedConversation(conversation)}
                            >
                              <div className="avatar-mini me-2">
                                {conversation.patient?.prenom?.[0]}{conversation.patient?.nom?.[0]}
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>{conversation.patient?.prenom} {conversation.patient?.nom}</span>
                                  {conversation.unreadCount > 0 && (
                                    <span className="badge bg-danger rounded-pill">{conversation.unreadCount}</span>
                                  )}
                                </div>
                                <small className="text-muted">
                                  {conversation.lastMessage || "Nouvelle conversation"}
                                </small>
                              </div>
                            </button>
                          ))
                        ) : (
                          <div className="text-center py-4">
                            <p className="text-muted">Aucune conversation</p>
                          </div>
                        )}
                      </div>
                    )}
                    
                    {messagingTab === 'patients' && (
                      <div className="list-group list-group-flush">
                        {filteredMessagePatients.length > 0 ? (
                          filteredMessagePatients.map(patient => (
                            <button
                              key={patient.id}
                              className="list-group-item list-group-item-action d-flex align-items-center"
                              onClick={() => startConversationWithPatient(patient)}
                            >
                              <div className="avatar-mini me-2">
                                {patient.prenom?.[0]}{patient.nom?.[0]}
                              </div>
                              <div className="flex-grow-1">
                                <span>{patient.prenom} {patient.nom}</span>
                              </div>
                            </button>
                          ))
                        ) : (
                          <div className="text-center py-4">
                            <p className="text-muted">Aucun patient trouvé</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="mobile-messagerie-view">
                    <div className="mobile-conversation-header">
                      <button 
                        className="btn btn-sm btn-link text-dark"
                        onClick={() => setSelectedConversation(null)}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </button>
                      <div className="d-flex align-items-center ms-2">
                        <div className="avatar-mini me-2">
                          {selectedConversation.patient?.prenom?.[0]}{selectedConversation.patient?.nom?.[0]}
                        </div>
                        <div>
                          <h6 className="mb-0">{selectedConversation.patient?.prenom} {selectedConversation.patient?.nom}</h6>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mobile-messages-container">
                      {loadingMessages ? (
                        <div className="text-center p-4">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Chargement...</span>
                          </div>
                        </div>
                      ) : messages.length === 0 ? (
                        <div className="text-center p-4">
                          <FontAwesomeIcon icon={faComment} size="3x" className="text-muted mb-3" />
                          <p>Aucun message. Commencez la conversation!</p>
                        </div>
                      ) : (
                        <div className="mobile-messages-list">
                          {messages.map(message => {
                            const isOwn = message.senderId === auth.currentUser.uid;
                            return (
                              <div key={message.id} className={`mobile-message ${isOwn ? 'mobile-message-own' : 'mobile-message-other'}`}>
                                <div className="mobile-message-content">
                                  {message.text && <div className="mobile-message-text">{message.text}</div>}
                                  
                                  {/* Aperçu des fichiers attachés */}
                                  {message.attachment && (
                                    <div className="message-attachment" onClick={() => handleOpenFilePreview(message.attachment)}>
                                      <div className="attachment-preview-card">
                                        <div className="attachment-icon">
                                          {message.attachment.type.startsWith('image/') ? (
                                            <img 
                                              src={message.attachment.url} 
                                              alt="aperçu" 
                                              className="attachment-thumbnail"
                                            />
                                          ) : (
                                            <FontAwesomeIcon 
                                              icon={
                                                message.attachment.type.includes('pdf') ? faFilePdf :
                                                message.attachment.type.includes('word') ? faFileWord :
                                                message.attachment.type.includes('excel') ? faFileExcel :
                                                faFile
                                              } 
                                              size="2x"
                                            />
                                          )}
                                        </div>
                                        <div className="attachment-info">
                                          <span className="attachment-name">{message.attachment.name}</span>
                                          <span className="attachment-size">
                                            {(message.attachment.size / 1024).toFixed(1)} KB
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
    
                                  {/* Aperçu des fichiers audio */}
                                  {message.audioAttachment && (
                                    <div className="message-audio">
                                      <audio controls src={message.audioAttachment.url} className="audio-player">
                                        Votre navigateur ne supporte pas l'élément audio.
                                      </audio>
                                      <div className="audio-duration">
                                        {formatRecordingTime(message.audioAttachment.duration)}
                                      </div>
                                    </div>
                                  )}
    
                                  <div className="mobile-message-time">
                                    {message.timestamp ? 
                                      new Date(message.timestamp.toDate()).toLocaleTimeString([], {
                                        hour: '2-digit', 
                                        minute:'2-digit'
                                      }) : 
                                      'Envoi...'
                                    }
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          <div ref={messagesEndRef} />
                        </div>
                      )}
                    </div>
                    
                    <form className="mobile-message-input-form" onSubmit={sendMessage}>
                      {attachmentFile && (
                        <div className="attachment-preview">
                          <div className="attachment-info">
                            <FontAwesomeIcon icon={faFile} className="me-2" />
                            <span className="text-truncate">{attachmentFile.name}</span>
                          </div>
                          <button type="button" className="btn-close" onClick={removeAttachment}></button>
                        </div>
                      )}
                      
                      {audioBlob && !isRecording && (
                        <div className="attachment-preview">
                          <div className="attachment-info">
                            <FontAwesomeIcon icon={faMicrophone} className="me-2" />
                            <span>Note vocale ({formatRecordingTime(recordingTime)})</span>
                          </div>
                          <button type="button" className="btn-close" onClick={removeAudio}></button>
                        </div>
                      )}
                      
                      {isRecording && (
                        <div className="recording-indicator">
                          <div className="pulse"></div>
                          <span>Enregistrement... {formatRecordingTime(recordingTime)}</span>
                          <div className="recording-controls">
                            <button type="button" className="btn btn-danger btn-sm" onClick={cancelRecording}>
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                            <button type="button" className="btn btn-success btn-sm" onClick={stopRecording}>
                              <FontAwesomeIcon icon={faCheck} />
                            </button>
                          </div>
                        </div>
                      )}
                      
                      <div className="input-group">
                        <button 
                          type="button" 
                          className="btn btn-light" 
                          onClick={() => document.getElementById('mobile-file-attachment').click()}
                        >
                          <FontAwesomeIcon icon={faPaperclip} />
                        </button>
                        <input 
                          id="mobile-file-attachment" 
                          type="file" 
                          className="d-none" 
                          onChange={handleMessageFileChange} 
                        />
                        
                        <button 
                          type="button" 
                          className={`btn ${isRecording ? 'btn-danger' : 'btn-light'}`}
                          onClick={isRecording ? stopRecording : startRecording}
                        >
                          <FontAwesomeIcon icon={isRecording ? faStop : faMicrophone} />
                        </button>
                        
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Écrivez votre message..."
                          value={newMessage}
                          onChange={(e) => setNewMessage(e.target.value)}
                          disabled={sendingMessage || isRecording}
                        />
                        <button 
                          className="btn btn-primary" 
                          type="submit"
                          disabled={((!newMessage.trim() && !attachmentFile && !audioBlob) || sendingMessage || isRecording)}
                        >
                          {sendingMessage ? (
                            <FontAwesomeIcon icon={faCircleNotch} spin />
                          ) : (
                            <FontAwesomeIcon icon={faPaperPlane} />
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          )}
    
          {/* Onglet Mot de passe */}
          {activeTab === 'password' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                      Mettre à jour le mot de passe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
    
        {/* Navigation inférieure pour mobile */}
        <div className="mobile-bottom-nav">
          <button 
            className={activeTab === 'rendezvous' ? 'active' : ''}
            onClick={() => setActiveTab('rendezvous')}
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>Rendez-vous</span>
          </button>
          <button 
            className={activeTab === 'patients' ? 'active' : ''}
            onClick={() => setActiveTab('patients')}
          >
            <FontAwesomeIcon icon={faUser} />
            <span>Patients</span>
          </button>
          <button 
            className={`messaging-btn ${activeTab === 'messagerie' ? 'active' : ''}`}
            onClick={() => setActiveTab('messagerie')}
          >
            <FontAwesomeIcon icon={faComments} />
            <span>Messages</span>
            {unreadMessagesCount > 0 && (
              <span className="unread-badge">{unreadMessagesCount}</span>
            )}
          </button>
          <button 
            className={activeTab === 'info' ? 'active' : ''}
            onClick={() => setActiveTab('info')}
          >
            <FontAwesomeIcon icon={faUserMd} />
            <span>Profil</span>
          </button>
          <button onClick={toggleMobileMenu}>
            <FontAwesomeIcon icon={faBars} />
            <span>Menu</span>
          </button>
        </div>
    
        {/* Modales et vues détaillées */}
        {showDetails && (
          <div className="mobile-detail-view">
            <div className="mobile-detail-header">
              <button className="btn btn-sm btn-link text-dark" onClick={() => setShowDetails(false)}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <h5 className="mb-0">
                {detailsType === 'rdv' && 'Détails du rendez-vous'}
                {detailsType === 'patient' && 'Fiche patient'}
              </h5>
              <div style={{ width: '24px' }}></div> {/* Spacer pour centrer le titre */}
            </div>
            
            <div className="mobile-detail-content">
              {detailsType === 'rdv' && detailsItem && (
                <div className="p-3">
                  <div className="card mb-3">
                    <div className="card-header">
                      <h6 className="mb-0">Informations générales</h6>
                    </div>
                    <div className="card-body">
                      <p><strong>Date:</strong> {new Date(detailsItem.date).toLocaleDateString()}</p>
                      <p><strong>Heure:</strong> {detailsItem.heure}</p>
                      <p><strong>Structure:</strong> {getStructureById(detailsItem.structureId).nom}</p>
                      <p><strong>Motif:</strong> {detailsItem.motif || 'Non spécifié'}</p>
                      <p>
                        <strong>Statut:</strong> 
                        {editingStatus ? (
                          <div className="input-group mt-1">
                            <select 
                              className="form-select"
                              value={newStatus}
                              onChange={(e) => setNewStatus(e.target.value)}
                            >
                              <option value="confirmé">Confirmé</option>
                              <option value="terminé">Terminé</option>
                              <option value="annulé">Annulé</option>
                            </select>
                            <button 
                              className="btn btn-success"
                              onClick={saveStatusChange}
                            >
                              <FontAwesomeIcon icon={faCheck} />
                            </button>
                            <button 
                              className="btn btn-secondary"
                              onClick={cancelEditStatus}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </div>
                        ) : (
                          <span 
                            className={`badge status-badge-${detailsItem.statut}`}
                            onClick={() => startEditStatus(detailsItem)}
                          >
                            {detailsItem.statut.charAt(0).toUpperCase() + detailsItem.statut.slice(1)}
                            <FontAwesomeIcon icon={faPencilAlt} className="ms-2" />
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                  
                  {detailsItem.patientId && (
                    <div className="card mb-3">
                      <div className="card-header">
                        <h6 className="mb-0">Patient</h6>
                      </div>
                      <div className="card-body">
                        {(() => {
                          const patient = getPatientById(detailsItem.patientId);
                          return patient ? (
                            <div>
                              <p><strong>Nom:</strong> {patient.prenom} {patient.nom}</p>
                              <p><strong>Âge:</strong> {calculateAge(patient.dateNaissance)} ans</p>
                              <p><strong>Téléphone:</strong> {patient.telephone || 'Non spécifié'}</p>
                              <p><strong>Email:</strong> {patient.email || 'Non spécifié'}</p>
                              <div className="d-grid">
                                <button 
                                  className="btn btn-outline-primary"
                                  onClick={() => {
                                    setShowDetails(false);
                                    setTimeout(() => {
                                      handleViewDetails('patient', patient);
                                    }, 300);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faUserMd} className="me-1" />
                                  Voir la fiche complète
                                </button>
                              </div>
                            </div>
                          ) : (
                            <p className="text-muted">Informations du patient non disponibles</p>
                          );
                        })()}
                      </div>
                    </div>
                  )}
                  
                  <div className="card">
                    <div className="card-header">
                      <h6 className="mb-0">Notes</h6>
                    </div>
                    <div className="card-body">
                      <textarea 
                        className="form-control mb-3"
                        rows="4"
                        placeholder="Ajoutez des notes concernant ce rendez-vous..."
                        value={detailsItem.notes || ''}
                        onChange={(e) => {
                          // Mettre à jour les notes localement
                          setDetailsItem({...detailsItem, notes: e.target.value});
                        }}
                      ></textarea>
                      <div className="d-grid">
                        <button 
                          className="btn btn-primary"
                          onClick={() => {
                            // Sauvegarder les notes
                            handleSaveRdvNotes(detailsItem.id, detailsItem.notes);
                          }}
                        >
                          <FontAwesomeIcon icon={faSave} className="me-1" />
                          Enregistrer les notes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {detailsType === 'patient' && detailsItem && (
                <div className="p-3">
                  <div className="text-center mb-4">
                    <div className="avatar-circle bg-primary text-white mx-auto">
                      {detailsItem.prenom?.charAt(0)}{detailsItem.nom?.charAt(0)}
                    </div>
                    <h4 className="mt-2">{detailsItem.prenom} {detailsItem.nom}</h4>
                    <span className="badge bg-secondary">
                      {calculateAge(detailsItem.dateNaissance)} ans
                    </span>
                  </div>
                  
                  <ul className="nav nav-pills nav-justified mb-3">
                    <li className="nav-item">
                      <button 
                        className={`nav-link ${patientDetailTab === 'info' ? 'active' : ''}`}
                        onClick={() => setPatientDetailTab('info')}
                      >
                        Infos
                      </button>
                    </li>
                    <li className="nav-item">
                      <button 
                        className={`nav-link ${patientDetailTab === 'medical' ? 'active' : ''}`}
                        onClick={() => setPatientDetailTab('medical')}
                      >
                        Médical
                      </button>
                    </li>
                    <li className="nav-item">
                      <button 
                        className={`nav-link ${patientDetailTab === 'rdv' ? 'active' : ''}`}
                        onClick={() => setPatientDetailTab('rdv')}
                      >
                        Rendez-vous
                      </button>
                    </li>
                  </ul>
                  
                  {patientDetailTab === 'info' && (
                    <div>
                      <div className="card mb-3">
                        <div className="card-header">
                          <h6 className="mb-0">Informations personnelles</h6>
                        </div>
                        <div className="card-body">
                          <p><strong>Date de naissance:</strong> {new Date(detailsItem.dateNaissance).toLocaleDateString()}</p>
                          <p><strong>Sexe:</strong> {detailsItem.sexe || 'Non spécifié'}</p>
                          <p><strong>Téléphone:</strong> {detailsItem.telephone || 'Non spécifié'}</p>
                          <p><strong>Email:</strong> {detailsItem.email || 'Non spécifié'}</p>
                          <p><strong>Adresse:</strong> {detailsItem.adresse || 'Non spécifiée'}</p>
                        </div>
                      </div>
                      
                      <div className="card">
                        <div className="card-header">
                          <h6 className="mb-0">Assurances</h6>
                        </div>
                        <div className="card-body">
                          {detailsItem.assurances && detailsItem.assurances.length > 0 ? (
                            <div className="d-flex flex-wrap">
                              {detailsItem.assurances.map((assurance, index) => (
                                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                  {assurance}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <p className="text-muted">Aucune assurance spécifiée</p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {patientDetailTab === 'medical' && (
                    <div>
                      <div className="card mb-3">
                        <div className="card-header">
                          <h6 className="mb-0">Antécédents médicaux</h6>
                        </div>
                        <div className="card-body">
                          <p>{detailsItem.antecedentsMedicaux || 'Aucun antécédent médical spécifié'}</p>
                        </div>
                      </div>
                      
                      <div className="card mb-3">
                        <div className="card-header">
                          <h6 className="mb-0">Diagnostic</h6>
                        </div>
                        <div className="card-body">
                          <p>{detailsItem.diagnostics || 'Aucun diagnostic spécifié'}</p>
                        </div>
                      </div>
                      
                      <div className="card">
                        <div className="card-header">
                          <h6 className="mb-0">Notes médicales</h6>
                        </div>
                        <div className="card-body">
                          <textarea 
                            className="form-control mb-3"
                            rows="4"
                            placeholder="Ajoutez des notes médicales concernant ce patient..."
                            value={detailsItem.notesMedicales || ''}
                            onChange={(e) => {
                              setDetailsItem({...detailsItem, notesMedicales: e.target.value});
                            }}
                          ></textarea>
                          <div className="d-grid">
                            <button 
                              className="btn btn-primary"
                              onClick={() => {
                                handleSavePatientNotes(detailsItem.id, detailsItem.notesMedicales);
                              }}
                            >
                              <FontAwesomeIcon icon={faSave} className="me-1" />
                              Enregistrer les notes
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {patientDetailTab === 'rdv' && (
                    <div>
                      <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <h6 className="mb-0">Rendez-vous</h6>
                          <button 
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleNewAppointment(detailsItem.id)}
                          >
                            <FontAwesomeIcon icon={faPlus} className="me-1" />
                            Nouveau
                          </button>
                        </div>
                        <div className="card-body p-0">
                          {(() => {
                            const patientRdvs = rendezvous.filter(rdv => rdv.patientId === detailsItem.id);
                            return patientRdvs.length > 0 ? (
                              <div className="list-group list-group-flush">
                                {patientRdvs.map(rdv => (
                                  <div key={rdv.id} className={`list-group-item rdv-item-mobile status-${rdv.statut}`}>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <strong>{new Date(rdv.date).toLocaleDateString()}</strong>
                                      <span className={`badge status-badge-${rdv.statut}`}>
                                        {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                                      </span>
                                    </div>
                                    <p className="mb-1"><strong>Heure:</strong> {rdv.heure}</p>
                                    <p className="mb-1"><strong>Structure:</strong> {getStructureById(rdv.structureId).nom}</p>
                                    <p className="mb-0"><strong>Motif:</strong> {rdv.motif || 'Non spécifié'}</p>
                                    <div className="mt-2">
                                      <button 
                                        className="btn btn-sm btn-outline-primary w-100"
                                        onClick={() => {
                                          setShowDetails(false);
                                          setTimeout(() => {
                                            handleViewDetails('rdv', rdv);
                                          }, 300);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faEye} className="me-1" />
                                        Voir détails
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center py-4">
                                <p className="text-muted">Aucun rendez-vous pour ce patient</p>
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  )}
                  
                  <div className="d-grid gap-2 mt-4">
                    <button 
                      className="btn btn-outline-primary"
                      onClick={() => handleStartConversation(detailsItem)}
                    >
                      <FontAwesomeIcon icon={faComment} className="me-1" />
                      Envoyer un message
                    </button>
                    <button 
                      className="btn btn-outline-secondary"
                      onClick={() => handleCreateBackup(detailsItem)}
                    >
                      <FontAwesomeIcon icon={faArchive} className="me-1" />
                      Créer une sauvegarde
                    </button>
                  </div>
                </div>
              )}
            </div>
    
            {detailsType === 'date-events' && detailsItem && (
      <div className="p-3">
        <h4 className="mb-3">Rendez-vous du {detailsItem.date.toLocaleDateString()}</h4>
        <div className="list-group">
          {detailsItem.events.map(rdv => (
            <div key={rdv.id} className={`list-group-item rdv-item-mobile status-${rdv.statut}`}>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <strong>{rdv.heure}</strong>
                <span className={`badge status-badge-${rdv.statut}`}>
                  {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                </span>
              </div>
              <p className="mb-1"><strong>Patient:</strong> {rdv.patientNom || 'Non spécifié'}</p>
              <p className="mb-1"><strong>Structure:</strong> {getStructureById(rdv.structureId).nom}</p>
              <p className="mb-1"><strong>Motif:</strong> {rdv.motif || 'Non spécifié'}</p>
              <div className="mt-2">
                <button 
                  className="btn btn-sm btn-outline-primary w-100"
                  onClick={() => {
                    setShowDetails(false);
                    setTimeout(() => {
                      handleViewDetails('rdv', rdv);
                    }, 300);
                  }}
                >
                  <FontAwesomeIcon icon={faEye} className="me-1" />
                  Voir détails
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
    
          </div>
        )}
    
        {/* Prévisualisation de fichier */}
        {showFilePreview && previewFile && (
          <div className="mobile-file-preview" onClick={handleCloseFilePreview}>
            <div className="mobile-file-preview-content" onClick={e => e.stopPropagation()}>
              <div className="mobile-file-preview-header">
                <h6 className="mb-0 text-truncate">{previewFile.name}</h6>
                <button className="btn-close" onClick={handleCloseFilePreview}></button>
              </div>
              <div className="mobile-file-preview-body">
                {previewFile.type.startsWith('image/') ? (
                  <img 
                    src={previewFile.url} 
                    alt={previewFile.name} 
                    className="mobile-file-preview-image" 
                  />
                ) : previewFile.type.includes('pdf') ? (
                  <iframe 
                    src={previewFile.url} 
                    title={previewFile.name}
                    className="mobile-file-preview-document"
                  ></iframe>
                ) : (
                  <div className="mobile-file-preview-download">
                    <FontAwesomeIcon icon={faFile} size="3x" className="mb-3" />
                    <p>Ce type de fichier ne peut pas être prévisualisé</p>
                    <a 
                      href={previewFile.url} 
                      download={previewFile.name}
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faDownload} className="me-2" />
                      Télécharger
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
    
        {/* Styles spécifiques à la version mobile */}
        <style jsx>{`
          .dashboard-container.mobile {
            display: flex;
            flex-direction: column;
            height: 100vh;
            overflow: hidden;
          }
    
          .mobile-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;
            background-color: #fff;
            border-bottom: 1px solid #e0e0e0;
            position: sticky;
            top: 0;
            z-index: 1000;
          }
    
          .mobile-title {
            margin: 0;
            font-size: 1.25rem;
          }
    
          .mobile-avatar {
            width: 36px;
            height: 36px;
            background-color: #007bff;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
          }
    
          .menu-toggle, .close-menu {
            background: none;
            border: none;
            font-size: 1.25rem;
            padding: 5px;
          }
    
          .mobile-sidebar {
            position: fixed;
            top: 0;
            left: -100%;
            width: 80%;
            height: 100vh;
            background-color: #fff;
            z-index: 1100;
            transition: left 0.3s ease;
            box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
            overflow-y: auto;
          }
    
          .mobile-sidebar.open {
            left: 0;
          }
    
          .mobile-sidebar-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border-bottom: 1px solid #e0e0e0;
          }
    
          .mobile-sidebar-menu ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }
    
          .mobile-sidebar-menu li {
            display: flex;
            align-items: center;
            padding: 15px;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
          }
    
          .mobile-sidebar-menu li.active {
            background-color: #f8f9fa;
            border-left: 3px solid #007bff;
          }
    
          .mobile-sidebar-menu li svg {
            margin-right: 15px;
            width: 20px;
          }
    
          .mobile-sidebar-menu .badge {
            margin-left: auto;
          }
    
          .mobile-content {
            flex: 1;
            overflow-y: auto;
            padding: 15px;
            padding-bottom: 70px; /* Pour laisser de la place à la navigation inférieure */
          }
    
          .mobile-bottom-nav {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            background-color: #fff;
            border-top: 1px solid #e0e0e0;
            z-index: 1000;
          }
    
          .mobile-bottom-nav button {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 8px 0;
            background: none;
            border: none;
            color: #6c757d;
            font-size: 0.75rem;
          }
    
          .mobile-bottom-nav button svg {
            font-size: 1.25rem;
            margin-bottom: 4px;
          }
    
          .mobile-bottom-nav button.active {
            color: #007bff;
          }
    
          /* Styles pour le calendrier mobile */
          .mobile-calendar {
            width: 100%;
            overflow: hidden;
          }
    
          .mobile-calendar-header {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            text-align: center;
            font-weight: bold;
            background-color: #f8f9fa;
          }
    
          .mobile-calendar-cell {
            padding: 8px 0;
            text-align: center;
            border: 1px solid #e0e0e0;
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
          }
    
          .mobile-calendar-body {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
          }
    
          .mobile-calendar-cell.other-month {
            color: #adb5bd;
          }
    
          .mobile-calendar-cell.has-events {
            background-color: #e8f4ff;
          }
    
          .event-indicator {
            position: absolute;
            bottom: 2px;
            left: 50%;
            transform: translateX(-50%);
          }
    
          .event-dot {
            width: 5px;
            height: 5px;
            background-color: #007bff;
            border-radius: 50%;
          }
    
          /* Styles pour les vues détaillées */
          .mobile-detail-view {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #fff;
            z-index: 1200;
            display: flex;
            flex-direction: column;
            animation: slideIn 0.3s forwards;
          }
    
          @keyframes slideIn {
            from {
              transform: translateX(100%);
            }
            to {
              transform: translateX(0);
            }
          }
    
          .mobile-detail-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border-bottom: 1px solid #e0e0e0;
            background-color: #f8f9fa;
          }
    
          .mobile-detail-content {
            flex: 1;
            overflow-y: auto;
            padding: 15px;
          }
    
          /* Styles pour la messagerie mobile */
          .mobile-messaging {
            height: calc(100vh - 170px);
            display: flex;
            flex-direction: column;
          }
    
          .mobile-tabs {
            display: flex;
            border-bottom: 1px solid #e0e0e0;
          }
    
          .mobile-tab {
            flex: 1;
            text-align: center;
            padding: 10px;
            background: none;
            border: none;
            font-weight: 500;
            color: #6c757d;
          }
    
          .mobile-tab.active {
            color: #007bff;
            border-bottom: 2px solid #007bff;
          }
    
          .avatar-mini {
            width: 40px;
            height: 40px;
            background-color: #007bff;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
          }
    
          .mobile-messagerie-view {
            display: flex;
            flex-direction: column;
            height: calc(100vh - 170px);
          }
    
          .mobile-conversation-header {
            display: flex;
            align-items: center;
            padding: 10px;
            background-color: #f8f9fa;
            border-bottom: 1px solid #e0e0e0;
          }
    
          .mobile-messages-container {
            flex: 1;
            padding: 10px;
            overflow-y: auto;
          }
    
          .mobile-messages-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
    
          .mobile-message {
            display: flex;
            max-width: 80%;
          }
    
          .mobile-message-own {
            align-self: flex-end;
          }
    
          .mobile-message-other {
            align-self: flex-start;
          }
    
          .mobile-message-content {
            padding: 8px 12px;
            border-radius: 18px;
            position: relative;
          }
    
          .mobile-message-own .mobile-message-content {
            background-color: #007bff;
            color: white;
            border-bottom-right-radius: 4px;
          }
    
          .mobile-message-other .mobile-message-content {
            background-color: #f0f0f0;
            color: #212529;
            border-bottom-left-radius: 4px;
          }
    
          .mobile-message-text {
            margin-bottom: 2px;
            word-break: break-word;
            font-size: 14px;
          }
    
          .mobile-message-time {
            font-size: 10px;
            opacity: 0.7;
            text-align: right;
          }
    
          .mobile-message-input-form {
            padding: 10px;
            border-top: 1px solid #e0e0e0;
            background-color: #f8f9fa;
          }
    
          /* Styles pour la prévisualisation des fichiers */
          .mobile-file-preview {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1300;
          }
    
          .mobile-file-preview-content {
            background-color: white;
            border-radius: 8px;
            width: 90%;
            max-height: 80vh;
            display: flex;
            flex-direction: column;
          }
    
          .mobile-file-preview-header {
            padding: 10px;
            border-bottom: 1px solid #dee2e6;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
    
          .mobile-file-preview-body {
            padding: 10px;
            overflow: auto;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f8f9fa;
          }
    
          .mobile-file-preview-image {
            max-width: 100%;
            max-height: 60vh;
            object-fit: contain;
          }
    
          .mobile-file-preview-document {
            width: 100%;
            height: 60vh;
            border: none;
          }
    
          .mobile-file-preview-download {
            text-align: center;
            padding: 20px;
          }
    
          /* Styles pour les badges de statut */
          .status-badge-confirmé {
            background-color: #2c7be5;
          }
    
          .status-badge-terminé {
            background-color: #00d97e;
          }
    
          .status-badge-annulé {
            background-color: #e63757;
          }
    
          .status-row-confirmé {
            border-left: 3px solid #2c7be5;
          }
    
          .status-row-terminé {
            border-left: 3px solid #00d97e;
          }
    
          .status-row-annulé {
            border-left: 3px solid #e63757;
          }
    
          /* Styles pour les pièces jointes */
          .attachment-preview {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #f1f5f9;
            padding: 8px 12px;
            border-radius: 8px;
            margin-bottom: 8px;
          }
    
          .attachment-info {
            display: flex;
            align-items: center;
            font-size: 0.85rem;
            color: #475569;
            max-width: 80%;
          }
    
          .recording-indicator {
            display: flex;
            align-items: center;
            background-color: #fee2e2;
            padding: 8px 12px;
            border-radius: 8px;
            margin-bottom: 8px;
            color: #b91c1c;
          }
    
          .pulse {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #ef4444;
            margin-right: 10px;
            animation: pulse 1.5s infinite;
          }
    
          .recording-controls {
            margin-left: auto;
            display: flex;
            gap: 8px;
          }
    
          @keyframes pulse {
            0% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(1.2);
              opacity: 0.8;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
    
          .message-attachment {
            margin-top: 8px;
            cursor: pointer;
          }
    
               .attachment-preview-card {
            display: flex;
            align-items: center;
            background-color: rgba(255, 255, 255, 0.9);
            border-radius: 8px;
            padding: 8px;
            transition: background-color 0.2s;
          }
    
          .attachment-preview-card:hover {
            background-color: rgba(255, 255, 255, 1);
          }
    
          .attachment-icon {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
          }
    
          .attachment-thumbnail {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
    
          .attachment-info {
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }
    
          .attachment-name {
            font-size: 0.9rem;
            font-weight: 500;
            color: #1a1a1a;
            margin-bottom: 2px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
    
          .attachment-size {
            font-size: 0.8rem;
            color: #666;
          }
    
          .message-audio {
            margin-top: 8px;
            width: 100%;
          }
    
          .audio-player {
            width: 100%;
            height: 36px;
          }
    
          .audio-duration {
            font-size: 0.8rem;
            color: #666;
            text-align: right;
            margin-top: 4px;
          }
    
          /* Styles pour les onglets de sauvegarde */
          .nav-pills .nav-link {
            border-radius: 0.25rem;
            padding: 0.5rem;
            font-size: 0.875rem;
          }
    
          /* Styles pour les accordéons */
          .accordion-button {
            padding: 0.75rem 1rem;
          }
    
          .accordion-body {
            padding: 1rem;
          }
    
          /* Styles pour les rendez-vous dans la liste */
          .rdv-item-mobile {
            border-left: 4px solid #ccc;
            padding-left: 10px;
          }
    
          .rdv-item-mobile.status-confirmé {
            border-left-color: #2c7be5;
          }
    
          .rdv-item-mobile.status-terminé {
            border-left-color: #00d97e;
          }
    
          .rdv-item-mobile.status-annulé {
            border-left-color: #e63757;
          }
    
          /* Styles pour l'avatar */
          .avatar-circle {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.75rem;
            font-weight: bold;
          }
    
          /* Styles pour les onglets de navigation */
          .nav-justified .nav-item {
            flex-basis: 0;
            flex-grow: 1;
            text-align: center;
          }
    
          /* Styles pour les badges */
          .badge {
            font-size: 0.75rem;
            font-weight: 600;
            padding: 0.35em 0.65em;
          }
    
          /* Styles pour les boutons d'action */
          .btn-sm {
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
          }
    
          /* Styles pour les cartes */
          .card {
            margin-bottom: 1rem;
            border-radius: 0.5rem;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          }
    
          .card-header {
            background-color: #f8f9fa;
            border-bottom: 1px solid #e0e0e0;
            padding: 0.75rem 1rem;
          }
    
          /* Styles pour les listes */
          .list-group-item {
            padding: 0.75rem 1rem;
          }
    
          /* Styles pour l'overlay du menu */
          .mobile-menu-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1050;
            display: none;
          }
    
          .mobile-menu-overlay.active {
            display: block;
          }
    
          /* Styles pour les indicateurs de notification */
          .unread-badge {
            position: absolute;
            top: 4px;
            right: 50%;
            transform: translateX(12px);
            background-color: #e63757;
            color: white;
            min-width: 18px;
            height: 18px;
            border-radius: 9px;
            font-size: 10px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
          }
    
          /* Styles pour les formulaires */
          .form-control, .form-select {
            font-size: 0.875rem;
            padding: 0.375rem 0.75rem;
          }
    
          /* Styles pour les textes tronqués */
          .text-truncate {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        `}</style>
      </div>
    );
    
    
    
      }

  // Interface desktop
  return (
    <div className="dashboard-container">
      {/* Menu latéral */}
      <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
  <h3>{!sidebarCollapsed && `${medecinData?.titre || "Dr"}  ${medecinData?.nom}`}</h3>
  <button className="toggle-btn" onClick={toggleSidebar}>
    <FontAwesomeIcon icon={sidebarCollapsed ? faChevronRight : faChevronLeft} />
  </button>
</div>

        <div className="sidebar-menu">
          <ul>
            <li className={activeTab === 'info' ? 'active' : ''} onClick={() => setActiveTab('info')}>
              <FontAwesomeIcon icon={faUserMd} />
              {!sidebarCollapsed && <span>Mon Profil</span>}
            </li>
            <li className={activeTab === 'qrcodes' ? 'active' : ''} onClick={() => setActiveTab('qrcodes')}>
              <FontAwesomeIcon icon={faQrcode} />
              {!sidebarCollapsed && <span>Codes QR</span>}
            </li>
            <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => setActiveTab('rendezvous')}>
              <FontAwesomeIcon icon={faCalendarAlt} />
              {!sidebarCollapsed && <span>Rendez-vous</span>}
              <span className="badge bg-info">{rendezvous.length}</span>
            </li>
            <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => setActiveTab('patients')}>
              <FontAwesomeIcon icon={faUser} />
              {!sidebarCollapsed && <span>Patients</span>}
              <span className="badge bg-info">{patients.length}</span>
            </li>

            <li className={activeTab === 'messagerie' ? 'active' : ''} onClick={() => setActiveTab('messagerie')}>
              <FontAwesomeIcon icon={faComments} />
              {!sidebarCollapsed && <span>Messagerie</span>}
              {unreadMessagesCount > 0 && <span className="badge bg-danger">{unreadMessagesCount}</span>}
            </li>


            <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => setActiveTab('affiliations')} style={{ position: 'relative' }}>
              <FontAwesomeIcon icon={faClinicMedical} />
              {!sidebarCollapsed && <span>Affiliations</span>}
              {pendingAffiliations.length > 0 && 
                <span className="badge bg-danger" style={{
                  position: 'absolute',
                  top: '5px',
                  right: sidebarCollapsed ? '5px' : '15px',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                  padding: '0.35em 0.65em',
                  borderRadius: '50%',
                  minWidth: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>{pendingAffiliations.length}</span>
              }
            </li>
            <li className={activeTab === 'sauvegardes' ? 'active' : ''} onClick={() => setActiveTab('sauvegardes')}>
  <FontAwesomeIcon icon={faArchive} />
  {!sidebarCollapsed && <span>Sauvegardes</span>}
  <span className="badge bg-info">{backups.length}</span>
</li>
            
  
            <li className={activeTab === 'password' ? 'active' : ''} onClick={() => setActiveTab('password')}>
              <FontAwesomeIcon icon={faKey} />
              {!sidebarCollapsed && <span>Mot de passe</span>}
            </li>
            <li onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              {!sidebarCollapsed && <span>Déconnexion</span>}
            </li>
          </ul>
        </div>
      </div>

      {/* Contenu principal */}
      <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        {/* En-tête avec le titre de la section active */}
        <div className="content-header">
          <h2>
            {activeTab === 'info' && 'Mon Profil'}
            {activeTab === 'qrcodes' && 'Gestion des Codes QR'}
            {activeTab === 'rendezvous' && 'Mes Rendez-vous'}
            {activeTab === 'patients' && 'Mes Patients'}
            {activeTab === 'messagerie' && 'Messagerie'}
            {activeTab === 'affiliations' && 'Mes Affiliations'}
            {activeTab === 'sauvegardes' && 'Sauvegardes'}
            {activeTab === 'password' && 'Modification du mot de passe'}
          </h2>
        </div>

        {/* Affichage des messages de notification */}
        {message && (
          <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
            {message}
            <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
          </div>
        )}

        {/* Contenu des différents onglets */}
        <div className="content-body">
          {/* Onglet Mon Profil */}
          {activeTab === 'info' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row">
                <div className="col-md-4 text-center mb-4">
  <div className="avatar-circle bg-primary text-white mx-auto">
    {medecinData?.prenom?.charAt(0)}{medecinData?.nom?.charAt(0)}
  </div>
  <h4 className="mt-3">{medecinData?.titre || "Dr"} {medecinData?.nom}</h4>
  <span className="badge bg-info">{medecinData?.specialite}</span>
</div>

                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prénom et Nom</label>
                        <input
                          name="nom"
                          value={form.nom || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Nom"
                        />
                      </div>
                     
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Spécialité</label>
                        <input
                          name="specialite"
                          value={form.specialite || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Spécialité"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Téléphone</label>
                        <input
                          name="telephone"
                          value={form.telephone || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Téléphone"
                        />
                      </div>
                    </div>
                    
                    <div className="row">
  <div className="col-md-6 mb-3">
    <label className="form-label">Email</label>
    <input
      name="email"
      value={form.email || ''}
      onChange={handleChange}
      className="form-control"
      placeholder="Email"
      disabled
    />
  </div>
  <div className="col-md-6 mb-3">
    <label className="form-label">Options de consultation</label>
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="consultationDomicile"
        name="consultationDomicile"
        checked={form.consultationDomicile || false}
        onChange={(e) => {
          setForm({
            ...form,
            consultationDomicile: e.target.checked
          });
        }}
      />
      <label className="form-check-label" htmlFor="consultationDomicile">
        <FontAwesomeIcon icon={faHome} className="me-2 text-success" />
        Accepte les consultations à domicile
      </label>
    </div>
  </div>
</div>

                  </div>
                </div>
                
                <div className="mb-3">
  <label className="form-label">Disponibilités</label>
  <div className="table-responsive">
    <table className="table">
      <thead>
        <tr>
          <th>Jour</th>
          <th>Disponible</th>
          <th>Créneaux</th>
        </tr>
      </thead>
      <tbody>
        {form.disponibilites && Object.entries(form.disponibilites).map(([jour, dispo]) => (
          <tr key={jour}>
            <td>{jour.charAt(0).toUpperCase() + jour.slice(1)}</td>
            <td>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`disponible-${jour}`}
                  checked={dispo.actif || false}
                  onChange={() => handleDisponibiliteChange(jour, "actif")}
                />
                <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                  {dispo.actif ? 'Oui' : 'Non'}
                </label>
              </div>
            </td>
            <td>
              {dispo.actif && (
                <div className="creneaux-container">
                  {dispo.creneaux.map((creneau, index) => (
                    <div key={index} className="creneau-row mb-2">
                      <div className="row g-2 align-items-center">
                        <div className="col-md-3">
                          <label className="form-label small mb-0">Début</label>
                          <input
                            type="time"
                            className="form-control form-control-sm"
                            value={creneau.debut}
                            onChange={(e) => handleDisponibiliteChange(jour, "debut", e.target.value, index)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label small mb-0">Fin</label>
                          <input
                            type="time"
                            className="form-control form-control-sm"
                            value={creneau.fin}
                            onChange={(e) => handleDisponibiliteChange(jour, "fin", e.target.value, index)}
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label small mb-0">Structure</label>
                          <select
                            className="form-select form-select-sm"
                            value={creneau.structureId || ""}
                            onChange={(e) => handleDisponibiliteChange(jour, "structureId", e.target.value, index)}
                          >
                            <option value="">Sélectionner une structure</option>
                            {getAvailableStructures(jour, dispo).map(structure => (
                              <option key={structure.id} value={structure.id}>
                                {structure.nom}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-2">
                          <label className="form-label small mb-0">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger d-block w-100"
                            onClick={() => removeCreneau(jour, index)}
                            disabled={dispo.creneaux.length <= 1}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mt-2"
                    onClick={() => addCreneau(jour)}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                    Ajouter un créneau
                                    </button>
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

                
                <div className="text-end mt-3">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                    Mettre à jour
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Onglet Codes QR */}
          {activeTab === 'qrcodes' && (
            <QRCodeManager 
              medecinId={auth.currentUser?.uid} 
              affiliatedStructures={affiliatedStructures}
              medecinData={medecinData}
            />
          )}
    
          {/* Onglet Rendez-vous */}
          {activeTab === 'rendezvous' && (
            <div>
              <div className="card shadow-sm mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <div className="btn-group">
                    <button 
                      className={`btn ${viewMode === 'calendar' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setViewMode('calendar')}
                    >
                      <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                      Vue Calendrier
                    </button>
                    <button 
                      className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setViewMode('list')}
                    >
                      <FontAwesomeIcon icon={faList} className="me-2" />
                      Vue Liste
                    </button>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <div className="input-group me-2" style={{ maxWidth: '200px' }}>
                      <span className="input-group-text">Date</span>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={filtreDate}
                        onChange={(e) => setFiltreDate(e.target.value)}
                      />
                    </div>
                    
                    <select 
                      className="form-select me-2" 
                      style={{ maxWidth: '150px' }}
                      value={filtreStatut}
                      onChange={(e) => setFiltreStatut(e.target.value)}
                    >
                      <option value="tous">Tous statuts</option>
                      <option value="confirmé">Confirmé</option>
                      <option value="terminé">Terminé</option>
                      <option value="annulé">Annulé</option>
                    </select>
                    
                    <select 
  className="form-select" 
  style={{ maxWidth: '200px' }}
  value={filtreStructure}
  onChange={(e) => setFiltreStructure(e.target.value)}
>
  <option value="">Toutes structures</option>
  {affiliatedStructures.map(structure => (
    <option key={structure.id} value={structure.id}>
      {structure.nom}
    </option>
  ))}
</select>
                  </div>
                </div>
                
                <div className="card-body">
                  {viewMode === 'calendar' ? (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <button className="btn btn-outline-secondary" onClick={handlePrevMonth}>
                          <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
                          Mois précédent
                        </button>
                        <h4 className="mb-0">
                          {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                        </h4>
                        <button className="btn btn-outline-secondary" onClick={handleNextMonth}>
                          Mois suivant
                          <FontAwesomeIcon icon={faChevronRight} className="ms-1" />
                        </button>
                      </div>
                      
                      <div className="calendar-container">
                        <div className="calendar-header">
                          {['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].map((day, index) => (
                            <div key={index} className="calendar-cell header">
                              {day}
                            </div>
                          ))}
                        </div>
                        <div className="calendar-body">
                          {getMonthData().map((day, index) => (
                            <div 
                              key={index} 
                              className={`calendar-cell ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                              onClick={() => handleDateClick(day)}
                            >
                              <div className="date-number">{day.date.getDate()}</div>
                              {day.hasEvents && (
                                <div className="event-indicator">
                                  <span className="badge rounded-pill bg-primary">
                                    {day.events.length} {day.events.length > 1 ? 'rendez-vous' : 'rendez-vous'}
                                  </span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                          <th>N°</th>
                          <th>Date</th>
                            <th>Patient</th>
                            <th>Structure</th>
                            <th>Motif</th>
                            <th>Statut</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
    {filteredRendezvous.length > 0 ? (
      filteredRendezvous.map((rdv, index) => (
        <tr key={rdv.id} className={`status-row-${rdv.statut}`}>
          <td>
            <span className="badge rounded-pill bg-primary">
              {rdv.orderNumber || index + 1}
            </span>
          </td>
          <td>{new Date(rdv.date).toLocaleDateString()}</td>
          <td>{rdv.heure}</td>
          <td>
            {rdv.patientNom || 'Non spécifié'}
            {rdv.patientId && (
                                    <button 
                                      className="btn btn-sm btn-link p-0 ms-2"
                                      onClick={() => handleViewPatient(rdv.patientId)}
                                      title="Voir les détails du patient"
                                    >
                                      <FontAwesomeIcon icon={faEye} />
                                    </button>
                                  )}
                                </td>
                                <td>{getStructureById(rdv.structureId).nom}</td>
                                <td>{rdv.motif || 'Non spécifié'}</td>
                                <td>
                                  <span className={`badge status-badge-${rdv.statut}`}>
                                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                                  </span>
                                </td>
                                <td>
                                  <button 
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => handleViewDetails('rdv', rdv)}
                                  >
                                    <FontAwesomeIcon icon={faEye} className="me-1" />
                                    Détails
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-3">
                                Aucun rendez-vous trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

{activeTab === 'patients' && (
  <div>
    {/* Navigation interne */}
    <ul className="nav nav-tabs mb-4">
      <li className="nav-item">
        <button 
          className={`nav-link ${patientSubTab === 'list' ? 'active' : ''}`}
          onClick={() => setPatientSubTab('list')}
        >
          Liste des patients
        </button>
      </li>
      <li className="nav-item">
        <button 
          className={`nav-link ${patientSubTab === 'manage' ? 'active' : ''}`}
          onClick={() => setPatientSubTab('manage')}
        >
          Gestion des patients
        </button>
      </li>
    </ul>
    
    {/* Contenu conditionnel basé sur l'onglet sélectionné */}
    {patientSubTab === 'list' && (
      <div className="card shadow-sm">
        <div className="card-header bg-light">
          <h5 className="mb-0">Mes patients</h5>
        </div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {patients.length > 0 ? (
              patients.map((patient) => {
                // Trouver les rendez-vous associés à ce patient
                const patientRdvs = rendezvous.filter(rdv => rdv.patientId === patient.id);
                // Trouver les structures uniques associées aux rendez-vous
                const structureIds = [...new Set(patientRdvs.map(rdv => rdv.structureId))];
                const patientStructures = structureIds.map(id => getStructureById(id));
                
                return (
                  <div className="col" key={patient.id}>
                    <div className="card h-100 shadow-sm hover-card">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start">
                          <h5 className="card-title fs-6">{patient.prenom} {patient.nom}</h5>
                          <span className="badge bg-secondary">
                            {calculateAge(patient.dateNaissance)} ans
                          </span>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12 col-sm-6">
                            <p className="card-text small mb-1">
                              <i className="fas fa-phone me-2 text-secondary"></i>
                              {patient.telephone || 'Non spécifié'}
                            </p>
                          </div>
                          <div className="col-12 col-sm-6">
                            <p className="card-text small mb-1">
                              <i className="fas fa-envelope me-2 text-secondary"></i>
                              {patient.email || 'Non spécifié'}
                            </p>
                          </div>
                          <div className="col-12 col-sm-6">
                            <p className="card-text small mb-1">
                              <i className="fas fa-diagnoses me-2 text-secondary"></i>
                              {patient.diagnostics || 'Non spécifié'}
                            </p>
                          </div>
                        </div>
                        {patientStructures.length > 0 && (
                          <div className="mt-2">
                            <h6 className="fs-7 mb-1">Structures ou Prestataire de santé  associées:</h6>
                            <div className="d-flex flex-wrap">
                              {patientStructures.map((structure, index) => (
                                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                  {structure.nom}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="card-footer bg-transparent border-top-0 p-2">
                        <div className="d-flex justify-content-between">
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => handleManualArchivePatient(patient)}
                            title="Archiver ce patient"
                          >
                            <FontAwesomeIcon icon={faArchive} className="me-1" />
                            Archiver
                          </button>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleViewDetails('patient', getPatientById(patient.id))}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-1" />
                            Voir détails
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted small">Aucun patient associé à vos rendez-vous</p>
              </div>
            )}
          </div>
        </div>
      </div>
    )}
    
    {patientSubTab === 'manage' && (
      <div className="card shadow-sm">
        <div className="card-header bg-light">
          <h5 className="mb-0">Gestion des patients</h5>
        </div>
        <div className="card-body">
          <MedecinPatientManager 
            medecinId={auth.currentUser?.uid}
            affiliatedStructures={affiliatedStructures}
            patients={patients}
            onPatientAdd={(newPatient) => {
              setPatients(prevPatients => [...prevPatients, newPatient]);
            }}
            onPatientUpdate={(updatedPatient) => {
              setPatients(prevPatients => 
                prevPatients.map(p => p.id === updatedPatient.id ? updatedPatient : p)
              );
            }}
            onPatientArchive={(patientId) => {
              // Mettre à jour l'état pour refléter l'archivage
              setPatients(prevPatients => 
                prevPatients.map(p => p.id === patientId ? {...p, archived: true} : p)
              );
            }}
          />
        </div>
      </div>
    )}
  </div>
)}




          {/* Onglet Affiliations */}
          {activeTab === 'affiliations' && (
            <div>
              {/* Recherche et demande d'affiliation à de nouvelles structures */}
              <div className="card shadow-sm mb-4">
  <div className="card-header d-flex justify-content-between align-items-center">
    <h5 className="mb-0">Rechercher des structures ou Prestataires de santé</h5>
    <div>
      <button 
        className="btn btn-sm btn-outline-secondary me-2"
        onClick={cleanupAffiliationRequests}
        title="Nettoyer les demandes obsolètes"
      >
        <FontAwesomeIcon icon={faBroom} />
      </button>
      <button 
        className="btn btn-sm btn-outline-secondary"
        onClick={refreshAffiliations}
        disabled={loading}
      >
        <FontAwesomeIcon icon={faRedo} className={loading ? "fa-spin" : ""} />
        {!loading && <span className="ms-1">Rafraîchir</span>}
      </button>
    </div>
  </div>
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-8">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher une structure par nom ou spécialité..."
                          value={searchStructure}
                          onChange={(e) => setSearchStructure(e.target.value)}
                        />
                        <button className="btn btn-outline-primary" type="button">
                          <FontAwesomeIcon icon={faSearch} className="me-1" />
                          Rechercher
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <select 
                        className="form-select"
                        value={filtreSpecialite}
                        onChange={(e) => setFiltreSpecialite(e.target.value)}
                      >
                        <option value="">Toutes spécialités</option>
                        {specialites.map((specialite, index) => (
                          <option key={index} value={specialite}>{specialite}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Structure et/ou Prestataire de santé</th>
                          <th>Spécialités</th>
                          <th>Adresse</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredStructures.length > 0 ? (
                          filteredStructures.map(structure => {
                            // Vérifier si déjà affilié ou demande en cours
                            const isAffiliated = affiliatedStructures.some(s => s.id === structure.id);
                            const hasPendingRequest = sentAffiliationRequests.some(req => 
                              req.structureId === structure.id && req.status === "pending"
                            );
                            const hasRejectedRequest = sentAffiliationRequests.some(req => 
                              req.structureId === structure.id && req.status === "rejected"
                            );
                            
                            return (
                              <tr key={structure.id}>
                                <td>{structure.nom}</td>
                                <td>
                                  {Array.isArray(structure.specialites) ? (
                                    structure.specialites.map((specialite, index) => (
                                      <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                        {specialite}
                                      </span>
                                    ))
                                  ) : (
                                    <span className="text-muted">Aucune spécialité</span>
                                  )}
                                </td>
                                <td>{structure.adresse || 'Non spécifiée'}</td>
                                <td>
                                  {isAffiliated ? (
                                    <button 
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDesaffiliation(structure.id)}
                                    >
                                      <FontAwesomeIcon icon={faUnlink} className="me-1" />
                                      Se désaffilier
                                    </button>
                                  ) : hasPendingRequest ? (
                                    <span className="badge bg-warning text-dark">Demande en attente</span>
                                  ) : hasRejectedRequest ? (
                                    <span className="badge bg-danger">Demande rejetée</span>
                                  ) : (
                                    <button 
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => handleRequestAffiliation(structure.id)}
                                    >
                                      <FontAwesomeIcon icon={faLink} className="me-1" />
                                      Demander affiliation
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center py-3">
                              Aucune structure trouvée
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              
              {/* Demandes d'affiliation en cours */}
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>Mes demandes d'affiliation en cours</h5>
                </div>
                <div className="card-body">
                  {sentAffiliationRequests.filter(req => req.status === "pending").length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Structure ou Prestataire</th>
                            <th>Date de la demande</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sentAffiliationRequests.filter(req => req.status === "pending").map(request => (
                            <tr key={request.id}>
                              <td>{request.structureName}</td>
                              <td>{new Date(request.createdAt.toDate()).toLocaleDateString()}</td>
                              <td>
                                <button 
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleCancelRequest(request.id)}
                                >
                                  <FontAwesomeIcon icon={faTimes} className="me-1" />
                                  Annuler
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="alert alert-info">
                      Aucune demande d'affiliation en cours
                    </div>
                  )}
                </div>
              </div>
              
              {/* Structures affiliées */}
              <div className="card shadow-sm">
                <div className="card-header">
                  <h5>Mes structures et/ou prestataire affiliées</h5>
                </div>
                <div className="card-body">
                  {affiliatedStructures.length > 0 ? (
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                      {affiliatedStructures.map(structure => (
                        <div className="col" key={structure.id}>
                          <div className="card h-100 shadow-sm hover-card">
                            <div className="card-body">
                              <h5 className="card-title">{structure.nom}</h5>
                              <p className="card-text">
                                <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                                {structure.telephone || 'Non spécifié'}
                              </p>
                              <p className="card-text">
                                <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                                {structure.email || 'Non spécifié'}
                              </p>
                              <p className="card-text">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-secondary" />
                                {structure.adresse || 'Adresse non spécifiée'}
                              </p>
                             
                            </div>
                            <div className="card-footer bg-transparent">
                              <button 
                                className="btn btn-sm btn-outline-danger w-100"
                                onClick={() => handleDesaffiliation(structure.id)}
                              >
                                <FontAwesomeIcon icon={faUnlink} className="me-1" />
                                Se désaffilier
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="alert alert-info">
                      Aucune structure affiliée
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}


{/* Onglet Sauvegardes */}
{activeTab === 'sauvegardes' && (
  <div className="row">
    <div className="col-md-4">
      <div className="card shadow-sm mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Patients sauvegardés</h5>
          <div className="input-group input-group-sm" style={{ width: '60%' }}>
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher..."
              value={backupSearchTerm}
              onChange={(e) => setBackupSearchTerm(e.target.value)}
            />
            <button className="btn btn-outline-secondary" type="button">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
        </div>
        <div className="card-body p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div className="list-group list-group-flush">
            {backups
              .filter(backup => {
                const patientName = `${backup.patientData.prenom} ${backup.patientData.nom}`.toLowerCase();
                return patientName.includes(backupSearchTerm.toLowerCase());
              })
              .map(backup => (
                <button
                  key={backup.id}
                  className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${selectedBackup?.id === backup.id ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedBackup(backup);
                    setBackupNotes(backup.notes || '');
                    setBackupFiles(backup.files || []);
                  }}
                >
                  <div>
                    <div className="fw-bold">{backup.patientData.prenom} {backup.patientData.nom}</div>
                    <small className="text-muted">
                      Mis à jour le {new Date(backup.updatedAt).toLocaleDateString()}
                    </small>
                  </div>
                  <span className="badge bg-info rounded-pill">
                    {(backup.files || []).length} fichier(s)
                  </span>
                </button>
              ))}
            {backups.length === 0 && (
              <div className="text-center py-4 text-muted">
                Aucune sauvegarde trouvée
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    
    <div className="col-md-8">
      {selectedBackup ? (
        <div className="card shadow-sm">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">
              {selectedBackup.patientData.prenom} {selectedBackup.patientData.nom}
              <span className="badge bg-light text-dark ms-2">
                {calculateAge(selectedBackup.patientData.dateNaissance)} ans
              </span>
            </h5>
          </div>
          <div className="card-body">
            <ul className="nav nav-tabs" id="backupTabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link active" 
                  id="info-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#info-content" 
                  type="button" 
                  role="tab"
                >
                  Informations
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link" 
                  id="rdv-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#rdv-content" 
                  type="button" 
                  role="tab"
                >
                  Rendez-vous
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link" 
                  id="notes-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#notes-content" 
                  type="button" 
                  role="tab"
                >
                  Notes
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button 
                  className="nav-link" 
                  id="files-tab" 
                  data-bs-toggle="tab" 
                  data-bs-target="#files-content" 
                  type="button" 
                  role="tab"
                >
                  Fichiers
                </button>
              </li>
            </ul>
            
            <div className="tab-content pt-3" id="backupTabsContent">
              {/* Onglet Informations */}
              <div className="tab-pane fade show active" id="info-content" role="tabpanel">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Date de naissance</label>
                    <p>{new Date(selectedBackup.patientData.dateNaissance).toLocaleDateString()}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Sexe</label>
                    <p>{selectedBackup.patientData.sexe || 'Non spécifié'}</p>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Téléphone</label>
                    <p>{selectedBackup.patientData.telephone || 'Non spécifié'}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Email</label>
                    <p>{selectedBackup.patientData.email || 'Non spécifié'}</p>
                  </div>
                </div>
                
                <div className="mb-3">
                  <label className="form-label fw-bold">Adresse</label>
                  <p>{selectedBackup.patientData.adresse || 'Non spécifiée'}</p>
                </div>
                
                <div className="mb-3">
                  <label className="form-label fw-bold">Assurances</label>
                  <div>
                    {selectedBackup.patientData.assurances && selectedBackup.patientData.assurances.map((assurance, index) => (
                      <span key={index} className="badge bg-light text-dark me-1 mb-1">
                        {assurance}
                      </span>
                    ))}
                    {(!selectedBackup.patientData.assurances || selectedBackup.patientData.assurances.length === 0) && (
                      <p className="text-muted">Aucune assurance spécifiée</p>
                    )}
                  </div>
                </div>
                
                <div className="mb-3">
                  <label className="form-label fw-bold">Antécédents médicaux</label>
                  <p className="text-muted">
                    {selectedBackup.patientData.antecedentsMedicaux || 'Non spécifiés'}
                  </p>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Diagnostic</label>
                  <p className="text-muted">
                    {selectedBackup.patientData.diagnostics || 'Non spécifié'}
                  </p>
                </div>
              </div>
              
              {/* Onglet Rendez-vous */}
              <div className="tab-pane fade" id="rdv-content" role="tabpanel">
                {selectedBackup.rendezVous && selectedBackup.rendezVous.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Heure</th>
                          <th>Structure</th>
                          <th>Motif</th>
                          <th>Statut</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedBackup.rendezVous.map((rdv, index) => (
                          <tr key={index} className={`status-row-${rdv.statut}`}>
                            <td>{new Date(rdv.date).toLocaleDateString()}</td>
                            <td>{rdv.heure}</td>
                            <td>{rdv.structureName || getStructureById(rdv.structureId).nom}</td>
                            <td>{rdv.motif || 'Non spécifié'}</td>
                            <td>
                              <span className={`badge status-badge-${rdv.statut}`}>
                                {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-info">
                    Aucun rendez-vous enregistré pour ce patient
                  </div>
                )}
              </div>
              
              {/* Onglet Notes */}
              <div className="tab-pane fade" id="notes-content" role="tabpanel">
                <div className="mb-3">
                  <label className="form-label">Notes de suivi</label>
                  <textarea 
                    className="form-control" 
                    rows="8"
                    value={backupNotes}
                    onChange={(e) => setBackupNotes(e.target.value)}
                    placeholder="Ajoutez vos notes concernant ce patient ici..."
                  ></textarea>
                </div>
                <div className="d-flex justify-content-end">
                  <button 
                    className="btn btn-primary"
                    onClick={handleSaveBackupNotes}
                    disabled={loading}
                  >
                    {loading ? (
                      <><FontAwesomeIcon icon={faCircleNotch} spin className="me-1" /> Enregistrement...</>
                    ) : (
                      <><FontAwesomeIcon icon={faSave} className="me-1" /> Enregistrer les notes</>
                    )}
                  </button>
                </div>
              </div>
              
              {/* Onglet Fichiers */}
              <div className="tab-pane fade" id="files-content" role="tabpanel">
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <label className="form-label">Fichiers associés</label>
                    <div>
                      <input
                        type="file"
                        id="backupFileInput"
                        className="d-none"
                        onChange={handleBackupFileChange}
                      />
                      <label htmlFor="backupFileInput" className="btn btn-sm btn-outline-primary mb-0">
                        <FontAwesomeIcon icon={faFileUpload} className="me-1" />
                        Ajouter un fichier
                      </label>
                    </div>
                  </div>
                  
                  {backupFileToUpload && (
                    <div className="alert alert-info d-flex justify-content-between align-items-center">
                      <div>
                        <FontAwesomeIcon icon={faFile} className="me-2" />
                        {backupFileToUpload.name}
                      </div>
                      <div>
                        <button 
                          className="btn btn-sm btn-primary me-2"
                          onClick={handleBackupFileUpload}
                          disabled={loading}
                        >
                          {loading ? (
                            <FontAwesomeIcon icon={faCircleNotch} spin />
                          ) : (
                            <FontAwesomeIcon icon={faFileUpload} />
                          )}
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => setBackupFileToUpload(null)}
                          disabled={loading}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>
                    </div>
                  )}
                  
                  <div className="list-group mt-3">
                    {backupFiles && backupFiles.length > 0 ? (
                      backupFiles.map((file, index) => (
                        <div key={index} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                          <div>
                            <FontAwesomeIcon 
                              icon={
                                file.type.includes('pdf') ? faFilePdf :
                                file.type.includes('word') ? faFileWord :
                                file.type.includes('excel') ? faFileExcel :
                                file.type.includes('image') ? faFile :
                                faFile
                              } 
                              className="me-2 text-primary"
                            />
                            {file.name}
                          </div>
                          <div>
                            <button 
                              className="btn btn-sm btn-outline-primary me-2"
                              onClick={() => handleDownloadBackupFile(file)}
                            >
                              <FontAwesomeIcon icon={faFileDownload} />
                            </button>
                            <button 
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDeleteBackupFile(file.id)}
                              disabled={loading}
                            >
                              <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center py-3 text-muted">
                        Aucun fichier associé à ce patient
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-4 d-flex justify-content-between">
              <button 
                className="btn btn-danger"
                onClick={() => handleDeleteBackup(selectedBackup.id)}
                disabled={loading}
              >
                <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
                Supprimer cette sauvegarde
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="card shadow-sm">
          <div className="card-body text-center py-5">
            <FontAwesomeIcon icon={faArchive} size="3x" className="text-muted mb-3" />
            <h5>Sélectionnez une sauvegarde</h5>
            <p className="text-muted">Choisissez un patient dans la liste pour voir ses détails</p>
          </div>
        </div>
      )}
    </div>
  </div>
)}


          {/* Onglet Messagerie */}
         {/* Onglet Messagerie */}
         {activeTab === 'messagerie' && (
            <div className="card shadow-sm">
              <div className="card-body p-0">
                <div className="messaging-container">
                  <div className="conversations-sidebar">
                    <div className="conversations-header">
                      <h5 className="mb-3">Conversations</h5>
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Rechercher un patient..."
                          value={searchPatientTerm}
                          onChange={(e) => setSearchPatientTerm(e.target.value)}
                        />
                        <button className="btn btn-outline-primary" type="button">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </div>
                    
                    <div className="patients-list">
                      <h6 className="sidebar-heading">Patients</h6>
                      {filteredMessagePatients.length > 0 ? (
                        <div className="list-group list-group-flush">
                          {filteredMessagePatients.map(patient => (
                            <button
                              key={patient.id}
                              className="list-group-item list-group-item-action d-flex align-items-center"
                              onClick={() => startConversationWithPatient(patient)}
                            >
                              <div className="avatar-mini me-2">
                                {patient.prenom?.[0]}{patient.nom?.[0]}
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>{patient.prenom} {patient.nom}</span>
                                </div>
                              </div>
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted text-center">Aucun patient trouvé</p>
                      )}
                    </div>
                    
                    <div className="conversations-list">
                      <h6 className="sidebar-heading">Conversations récentes</h6>
                      {conversations.length > 0 ? (
                        <div className="list-group list-group-flush">
                          {conversations.map(conversation => (
                            <button
                              key={conversation.id}
                              className={`list-group-item list-group-item-action d-flex align-items-center ${selectedConversation?.id === conversation.id ? 'active' : ''}`}
                              onClick={() => setSelectedConversation(conversation)}
                            >
                              <div className="avatar-mini me-2">
                                {conversation.patient?.prenom?.[0]}{conversation.patient?.nom?.[0]}
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-center">
                                  <span>{conversation.patient?.prenom} {conversation.patient?.nom}</span>
                                  {conversation.unreadCount > 0 && (
                                    <span className="badge bg-danger rounded-pill">{conversation.unreadCount}</span>
                                  )}
                                </div>
                                <small className="text-muted">
                                  {conversation.lastMessage || "Nouvelle conversation"}
                                </small>
                              </div>
                            </button>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted text-center">Aucune conversation</p>
                      )}
                    </div>
                  </div>
                  
                  <div className="messages-area">
                    {selectedConversation ? (
                      <>
                        <div className="messages-header">
                          <div className="d-flex align-items-center">
                            <div className="avatar-mini me-2">
                              {selectedConversation.patient?.prenom?.[0]}{selectedConversation.patient?.nom?.[0]}
                            </div>
                            <div>
                              <h5 className="mb-0">{selectedConversation.patient?.prenom} {selectedConversation.patient?.nom}</h5>
                            </div>
                          </div>
                        </div>
                        
                        <div className="messages-container">
                          {loadingMessages ? (
                            <div className="text-center p-4">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Chargement...</span>
                              </div>
                            </div>
                          ) : messages.length === 0 ? (
                            <div className="text-center p-4">
                              <FontAwesomeIcon icon={faComment} size="3x" className="text-muted mb-3" />
                              <p>Aucun message. Commencez la conversation!</p>
                            </div>
                          ) : (
                            <div className="messages-list">
                              {messages.map(message => {
                                const isOwn = message.senderId === auth.currentUser.uid;
                                return (
                                  <div key={message.id} className={`message ${isOwn ? 'message-own' : 'message-other'}`}>
                                    <div className="message-content">
                                      {message.text && <div className="message-text">{message.text}</div>}
                                      
                                      {/* Aperçu des fichiers attachés */}
                                      {message.attachment && (
                                        <div className="message-attachment" onClick={() => handleOpenFilePreview(message.attachment)}>
                                          <div className="attachment-preview-card">
                                            <div className="attachment-icon">
                                              {message.attachment.type.startsWith('image/') ? (
                                                <img 
                                                  src={message.attachment.url} 
                                                  alt="aperçu" 
                                                  className="attachment-thumbnail"
                                                />
                                              ) : (
                                                <FontAwesomeIcon 
                                                  icon={
                                                    message.attachment.type.includes('pdf') ? faFilePdf :
                                                    message.attachment.type.includes('word') ? faFileWord :
                                                    message.attachment.type.includes('excel') ? faFileExcel :
                                                    faFile
                                                  } 
                                                  size="2x"
                                                />
                                              )}
                                            </div>
                                            <div className="attachment-info">
                                              <span className="attachment-name">{message.attachment.name}</span>
                                              <span className="attachment-size">
                                                {(message.attachment.size / 1024).toFixed(1)} KB
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {/* Aperçu des fichiers audio */}
                                      {message.audioAttachment && (
                                        <div className="message-audio">
                                          <audio controls src={message.audioAttachment.url} className="audio-player">
                                            Votre navigateur ne supporte pas l'élément audio.
                                          </audio>
                                          <div className="audio-duration">
                                            {formatRecordingTime(message.audioAttachment.duration)}
                                          </div>
                                        </div>
                                      )}

                                      <div className="message-time">
                                        {message.timestamp ? 
                                          new Date(message.timestamp.toDate()).toLocaleTimeString([], {
                                            hour: '2-digit', 
                                            minute:'2-digit'
                                          }) : 
                                          'Envoi...'
                                        }
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                              <div ref={messagesEndRef} />
                            </div>
                          )}
                        </div>
                        
                        <form className="message-input-form" onSubmit={sendMessage}>
                          {attachmentFile && (
                            <div className="attachment-preview">
                              <div className="attachment-info">
                                <FontAwesomeIcon icon={faFile} className="me-2" />
                                <span>{attachmentFile.name}</span>
                              </div>
                              <button type="button" className="btn-close" onClick={removeAttachment}></button>
                            </div>
                          )}
                          
                          {audioBlob && !isRecording && (
                            <div className="attachment-preview">
                              <div className="attachment-info">
                                <FontAwesomeIcon icon={faMicrophone} className="me-2" />
                                <span>Note vocale ({formatRecordingTime(recordingTime)})</span>
                              </div>
                              <button type="button" className="btn-close" onClick={removeAudio}></button>
                            </div>
                          )}
                          
                          {isRecording && (
                            <div className="recording-indicator">
                              <div className="pulse"></div>
                              <span>Enregistrement en cours... {formatRecordingTime(recordingTime)}</span>
                              <div className="recording-controls">
                                <button type="button" className="btn btn-danger btn-sm" onClick={cancelRecording}>
                                  <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <button type="button" className="btn btn-success btn-sm" onClick={stopRecording}>
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              </div>
                            </div>
                          )}
                          
                          <div className="input-group">
                            <button 
                              type="button" 
                              className="btn btn-light" 
                              onClick={() => document.getElementById('file-attachment').click()}
                            >
                              <FontAwesomeIcon icon={faPaperclip} />
                            </button>
                            <input 
                              id="file-attachment" 
                              type="file" 
                              className="d-none" 
                              onChange={handleMessageFileChange} 
                            />
                            
                            <button 
                              type="button" 
                              className={`btn ${isRecording ? 'btn-danger' : 'btn-light'}`}
                              onClick={isRecording ? stopRecording : startRecording}
                            >
                              <FontAwesomeIcon icon={isRecording ? faStop : faMicrophone} />
                            </button>
                            
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Écrivez votre message..."
                              value={newMessage}
                              onChange={(e) => setNewMessage(e.target.value)}
                              disabled={sendingMessage || isRecording}
                            />
                            <button 
                              className="btn btn-primary" 
                              type="submit"
                              disabled={((!newMessage.trim() && !attachmentFile && !audioBlob) || sendingMessage || isRecording)}
                            >
                              {sendingMessage ? (
                                <FontAwesomeIcon icon={faCircleNotch} spin />
                              ) : (
                                <FontAwesomeIcon icon={faPaperPlane} />
                              )}
                            </button>
                          </div>
                        </form>
                      </>
                    ) : (
                      <div className="no-conversation-selected">
                        <FontAwesomeIcon icon={faComments} size="3x" className="text-muted mb-3" />
                        <h5>Sélectionnez une conversation</h5>
                        <p className="text-muted">Choisissez un patient pour commencer à discuter</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}


          {/* Onglet Mot de passe */}
          {activeTab === 'password' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                      Mettre à jour le mot de passe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}


  
        </div>
      </div>


      <DetailView 
  showDetails={showDetails}
  setShowDetails={setShowDetails}
  detailsType={detailsType}
  detailsItem={detailsItem}
  isMobile={isMobile}
  // Archives
 
  // Rdv
  editingStatus={editingStatus}
  newStatus={newStatus}
  setNewStatus={setNewStatus}
  // Functions
  calculateAge={calculateAge}
  getStructureById={getStructureById}
  getPatientById={getPatientById}
  startEditStatus={startEditStatus}
  saveStatusChange={saveStatusChange}
  cancelEditStatus={cancelEditStatus}
  // Fonction pour ouvrir la prévisualisation d'un fichier
  handleOpenFilePreview={handleOpenFilePreview}
  // Fonction pour fermer la prévisualisation
  handleCloseFilePreview={handleCloseFilePreview}
/>

{/* Ajoutez ce composant à la fin du rendu, juste avant la dernière balise fermante */}
{showFilePreview && previewFile && (
  <div className="file-preview-modal" onClick={handleCloseFilePreview}>
    <div className="file-preview-content" onClick={e => e.stopPropagation()}>
      <div className="file-preview-header">
        <h5>{previewFile.name}</h5>
        <button className="btn-close" onClick={handleCloseFilePreview}></button>
      </div>
      <div className="file-preview-body">
        {previewFile.type.startsWith('image/') ? (
          <img 
            src={previewFile.url} 
            alt={previewFile.name} 
            className="file-preview-image" 
          />
        ) : previewFile.type.includes('pdf') ? (
          <iframe 
            src={previewFile.url} 
            title={previewFile.name}
            className="file-preview-document"
          ></iframe>
        ) : (
          <div className="file-preview-download">
            <FontAwesomeIcon icon={faFile} size="3x" className="mb-3" />
            <p>Ce type de fichier ne peut pas être prévisualisé</p>
            <a 
              href={previewFile.url} 
              download={previewFile.name}
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              Télécharger le fichier
            </a>
          </div>
        )}
      </div>
    </div>
  </div>
)}




<style jsx>{`/* Styles pour la messagerie */
.messaging-container {
  display: flex;
  height: 70vh;
  overflow: hidden;
}

.conversations-sidebar {
  width: 300px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.conversations-header {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.sidebar-heading {
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #6c757d;
  padding: 10px 15px;
  margin: 0;
  background-color: #f8f9fa;
}

.patients-list, .conversations-list {
  flex: 1;
  overflow-y: auto;
}

.avatar-mini {
  width: 40px;
  height: 40px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.messages-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.messages-header {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.messages-container {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
}

.messages-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message {
  display: flex;
  max-width: 70%;
}

.message-own {
  align-self: flex-end;
}

.message-other {
  align-self: flex-start;
}

.message-content {
  padding: 10px 15px;
  border-radius: 18px;
  position: relative;
}

.message-own .message-content {
  background-color: #007bff;
  color: white;
  border-bottom-right-radius: 4px;
}

.message-other .message-content {
  background-color: #f0f0f0;
  color: #212529;
  border-bottom-left-radius: 4px;
}

.message-text {
  margin-bottom: 4px;
  word-break: break-word;
}

.message-time {
  font-size: 0.75rem;
  opacity: 0.7;
  text-align: right;
}

.message-input-form {
  padding: 15px;
  border-top: 1px solid #e0e0e0;
}

.no-conversation-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6c757d;
  text-align: center;
  padding: 20px;
}

/* Pour la version mobile */
@media (max-width: 767px) {
  .messaging-container {
    flex-direction: column;
    height: auto;
  }
  
  .conversations-sidebar {
    width: 100%;
    height: auto;
    max-height: 300px;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .messages-area {
    height: calc(100vh - 400px);
  }
}

/* Styles pour la messagerie mobile */
.mobile-messagerie-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 170px);
}

.mobile-conversation-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.mobile-messages-container {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
}

.mobile-messages-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-message {
  display: flex;
  max-width: 80%;
}

.mobile-message-own {
  align-self: flex-end;
}

.mobile-message-other {
  align-self: flex-start;
}

.mobile-message-content {
  padding: 8px 12px;
  border-radius: 18px;
  position: relative;
}

.mobile-message-own .mobile-message-content {
  background-color: #007bff;
  color: white;
  border-bottom-right-radius: 4px;
}

.mobile-message-other .mobile-message-content {
  background-color: #f0f0f0;
  color: #212529;
  border-bottom-left-radius: 4px;
}

.mobile-message-text {
  margin-bottom: 2px;
  word-break: break-word;
  font-size: 14px;
}

.mobile-message-time {
  font-size: 10px;
  opacity: 0.7;
  text-align: right;
}

.mobile-message-input-form {
  padding: 10px;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  position: sticky;
  bottom: 0;
}

.mobile-tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.mobile-tab {
  flex: 1;
  text-align: center;
  padding: 10px;
  background: none;
  border: none;
  font-weight: 500;
  color: #6c757d;
}

.mobile-tab.active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

/* Styles pour le bouton de messagerie dans la navigation mobile */
.mobile-bottom-nav button.messaging-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--ms-gray-130);
  font-size: 22px;
  padding: 8px;
  border: none;
  background: transparent;
  transition: color 0.2s ease;
}

.mobile-bottom-nav button.messaging-btn.active {
  color: var(--ms-blue);
}

.mobile-bottom-nav button.messaging-btn .unread-badge {
  position: absolute;
  top: 4px;
  right: 50%;
  transform: translateX(12px);
  background-color: var(--ms-red);
  color: white;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Styles pour la section messagerie mobile */

.attachment-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f1f5f9;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.attachment-info {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #475569;
}

.recording-indicator {
  display: flex;
  align-items: center;
  background-color: #fee2e2;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  color: #b91c1c;
}

.pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ef4444;
  margin-right: 10px;
  animation: pulse 1.5s infinite;
}

.recording-controls {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.message-attachment {
  margin-top: 8px;
  cursor: pointer;
}

.attachment-preview-card {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 8px;
  transition: background-color 0.2s;
}

.attachment-preview-card:hover {
  background-color: rgba(255, 255, 255, 1);
}

.attachment-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.attachment-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.attachment-info {
  display: flex;
  flex-direction: column;
}

.attachment-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.attachment-size {
  font-size: 0.8rem;
  color: #666;
}

.file-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.file-preview-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.file-preview-header {
  padding: 16px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-preview-body {
  padding: 16px;
  overflow: auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.file-preview-document {
  width: 100%;
  height: 70vh;
  border: none;
}

.file-preview-download {
  text-align: center;
  padding: 32px;
}

.message-audio {
  margin-top: 8px;
  width: 100%;
}

.audio-player {
  width: 100%;
  height: 36px;
}

.audio-duration {
  font-size: 0.8rem;
  color: #666;
  text-align: right;
  margin-top: 4px;
}

/* Ajoutez ces styles à votre fichier CSS */
.file-list {
  max-height: calc(100vh - 400px);
  overflow-y: auto;
}

.file-item {
  transition: all 0.2s ease;
}

.file-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 5px rgba(0,0,0,0.1);
}

.file-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-info {
  overflow: hidden;
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-meta {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #6c757d;
}

.file-actions {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.file-item:hover .file-actions {
  opacity: 1;
}

.archive-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060;
}

.archive-preview-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.archive-preview-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.archive-preview-body {
  padding: 1rem;
  overflow: auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.archive-preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.archive-preview-document {
  width: 100%;
  height: 70vh;
  border: none;
}


/* Ajoutez ces styles dans votre fichier CSS */
.file-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060;
}

.file-preview-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.file-preview-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-preview-body {
  padding: 1rem;
  overflow: auto;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.file-preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.file-preview-document {
  width: 100%;
  height: 70vh;
  border: none;
}

.file-preview-download {
  text-align: center;
  padding: 2rem;
}

.file-item {
  transition: transform 0.2s ease;
}

.file-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.file-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
  

/* Styles pour la section Sauvegardes */
.info-item {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.info-item:last-child {
  border-bottom: none;
}

.mobile-tab-content {
  display: none;
  padding: 10px 0;
}

.mobile-tab-content.active {
  display: block;
}

.rdv-item-mobile {
  border-left: 4px solid #ccc;
  padding-left: 10px;
}

.rdv-item-mobile.status-confirmé {
  border-left-color: #2c7be5;
}

.rdv-item-mobile.status-terminé {
  border-left-color: #00d97e;
}

.rdv-item-mobile.status-annulé {
  border-left-color: #e63757;
}

/* Styles pour la prévisualisation des fichiers */
.attachment-preview-card {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 10px;
}

.attachment-icon {
  margin-right: 10px;
  width: 40px;
  text-align: center;
}

.attachment-thumbnail {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}

.attachment-info {
  flex-grow: 1;
  overflow: hidden;
}

.attachment-name {
  display: block;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.attachment-size {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
}


  `}
</style>

    </div>

  );
};

export default MedecinDashboard;